"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5593,2928],{

/***/ 49770:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "XM": function() { return /* binding */ RECRUIT_LOGO_IMAGE_SIZE; },
/* harmony export */   "nF": function() { return /* binding */ LINKAREER_MAGAZINE_WIDTH_SIZE; },
/* harmony export */   "rE": function() { return /* binding */ LINKAREER_MAGAZINE_IMAGE_RENDER_WIDTH; },
/* harmony export */   "sF": function() { return /* binding */ LINKAREER_MAGAZINE_IMAGE_RENDER_HEIGHT; },
/* harmony export */   "w8": function() { return /* binding */ LINKAREER_MAGAZINE_HEIGHT_SIZE; }
/* harmony export */ });
var RECRUIT_LOGO_IMAGE_SIZE = 60;
var LINKAREER_MAGAZINE_WIDTH_SIZE = 140;
var LINKAREER_MAGAZINE_HEIGHT_SIZE = 70;
var LINKAREER_MAGAZINE_IMAGE_RENDER_WIDTH = 140;
var LINKAREER_MAGAZINE_IMAGE_RENDER_HEIGHT = 76;


/***/ }),

/***/ 72122:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30132);
/* harmony import */ var constants_typeText__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25536);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  padding: 56px 0px 24px;\n\n  .typo {\n    font-weight: bold;\n    cursor: default;\n    font-size: 26px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var ActivityListScreenHeaderDesktop = function(param) {
    var activityType = param.activityType, className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledWrapper, {
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h1", {
            className: "typo",
            children: constants_typeText__WEBPACK_IMPORTED_MODULE_2__/* .ACTIVITY_TYPE_TEXT */ .DK[activityType]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ActivityListScreenHeaderDesktop);
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "ActivityListScreenHeader.desktop__StyledWrapper",
    componentId: "sc-f055a5ff-0"
})(_templateObject());


/***/ }),

/***/ 1869:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

var orderByReducer = function(orderBy, action) {
    if (action.type === "ORDER_BY_UPDATE") {
        return action.orderBy;
    }
    return orderBy;
};
/* harmony default export */ __webpack_exports__["Z"] = (orderByReducer);


/***/ }),

/***/ 57346:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

var paginationReducer = function(page, action) {
    if (action.type === "PAGE_UPDATE") {
        return action.page;
    }
    return page;
};
/* harmony default export */ __webpack_exports__["Z"] = (paginationReducer);


/***/ }),

/***/ 22701:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "NU": function() { return /* binding */ PC_AD_CODE; },
/* harmony export */   "Q7": function() { return /* binding */ AD_CODE_ID; },
/* harmony export */   "s6": function() { return /* binding */ ACTIVITY_NOTICE_AD_CODE_ID; },
/* harmony export */   "xB": function() { return /* binding */ EDUCATION_RECOMMENDATION_AD_CODE_ID; }
/* harmony export */ });
/* unused harmony exports MOBILE_AD_CODE, ACTIVITY_NOTICE_AD_CODE */
var PC_AD_CODE;
(function(PC_AD_CODE) {
    PC_AD_CODE["MAIN"] = "pc-main-list-banner";
    PC_AD_CODE["HOTLINE"] = "pc-hotline-banner";
    PC_AD_CODE["RECOMMEND_ACTIVITY_S"] = "pc-recommend-activity-s-banner";
    PC_AD_CODE["RECOMMEND_ACTIVITY_A"] = "pc-recommend-activity-a-banner";
    PC_AD_CODE["WEEKLY_POPULAR"] = "pc-weekly-popular-activity";
    PC_AD_CODE["RECRUIT"] = "pc-recruit-banner";
    PC_AD_CODE["RIGHT_SIDEBAR"] = "pc-right-sidebar-all-of-page";
    PC_AD_CODE["HORIZONTAL"] = "web-activity-horizontal-ad";
    PC_AD_CODE["RECRUIT_QNA_BOTTOM"] = "pc-recruit-qna-bottom";
    PC_AD_CODE["COVER_LETTER_SEARCH"] = "pc-coverletter-search-banner";
    PC_AD_CODE["LIVE_ACTIVITY"] = "live-activity";
    PC_AD_CODE["FULLSCREEN_POPUP"] = "pc-full-popup";
    PC_AD_CODE["EDUCATION_TOP_PINNED_BANNER"] = "pc-education-top-pinned-banner";
})(PC_AD_CODE || (PC_AD_CODE = {}));
var MOBILE_AD_CODE;
(function(MOBILE_AD_CODE) {
    MOBILE_AD_CODE["MAIN"] = "mobile-main-list-banner";
    MOBILE_AD_CODE["HOTLINE"] = "mobile-hotline-banner";
    MOBILE_AD_CODE["RECOMMEND_ACTIVITY_S"] = "mobile-recommend-activity-s-banner";
    MOBILE_AD_CODE["RECOMMEND_ACTIVITY_A"] = "mobile-recommend-activity-a-banner";
    MOBILE_AD_CODE["WEEKLY_POPULAR"] = "mobile-weekly-popular-activity";
    MOBILE_AD_CODE["RECRUIT"] = "mobile-recruit-banner";
    MOBILE_AD_CODE["RECRUIT_QNA_BOTTOM"] = "mobile-recruit-qna-bottom";
    MOBILE_AD_CODE["COVER_LETTER_SEARCH"] = "mobile-coverletter-search-banner";
    MOBILE_AD_CODE["LIVE_ACTIVITY"] = "live-activity";
    MOBILE_AD_CODE["FULLSCREEN_POPUP"] = "mobile-full-popup";
    MOBILE_AD_CODE["EDUCATION_TOP_PINNED_BANNER"] = "mobile-education-top-pinned-banner";
})(MOBILE_AD_CODE || (MOBILE_AD_CODE = {}));
var AD_CODE_ID = {
    MAIN: {
        PC: PC_AD_CODE.MAIN,
        MOBILE: MOBILE_AD_CODE.MAIN
    },
    HOTLINE: {
        PC: PC_AD_CODE.HOTLINE,
        MOBILE: MOBILE_AD_CODE.HOTLINE
    },
    RECOMMEND_ACTIVITY_S: {
        PC: PC_AD_CODE.RECOMMEND_ACTIVITY_S,
        MOBILE: MOBILE_AD_CODE.RECOMMEND_ACTIVITY_S
    },
    RECOMMEND_ACTIVITY_A: {
        PC: PC_AD_CODE.RECOMMEND_ACTIVITY_A,
        MOBILE: MOBILE_AD_CODE.RECOMMEND_ACTIVITY_A
    },
    LIVE_ACTIVITY: {
        PC: PC_AD_CODE.LIVE_ACTIVITY,
        MOBILE: MOBILE_AD_CODE.LIVE_ACTIVITY
    },
    WEEKLY_POPULAR: {
        PC: PC_AD_CODE.WEEKLY_POPULAR,
        MOBILE: MOBILE_AD_CODE.WEEKLY_POPULAR
    },
    RECRUIT: {
        PC: PC_AD_CODE.RECRUIT,
        MOBILE: MOBILE_AD_CODE.RECRUIT
    },
    RIGHT_SIDEBAR: {
        PC: PC_AD_CODE.RIGHT_SIDEBAR
    },
    HORIZONTAL: {
        PC: PC_AD_CODE.HORIZONTAL
    },
    RECRUIT_QNA_BOTTOM: {
        PC: PC_AD_CODE.RECRUIT_QNA_BOTTOM,
        MOBILE: MOBILE_AD_CODE.RECRUIT_QNA_BOTTOM
    },
    COVER_LETTER_SEARCH: {
        PC: PC_AD_CODE.COVER_LETTER_SEARCH,
        MOBILE: MOBILE_AD_CODE.COVER_LETTER_SEARCH
    },
    FULLSCREEN_POPUP: {
        PC: PC_AD_CODE.FULLSCREEN_POPUP,
        MOBILE: MOBILE_AD_CODE.FULLSCREEN_POPUP
    },
    EDUCATION_TOP_PINNED_BANNER: {
        PC: PC_AD_CODE.EDUCATION_TOP_PINNED_BANNER,
        MOBILE: MOBILE_AD_CODE.EDUCATION_TOP_PINNED_BANNER
    }
};
var ACTIVITY_NOTICE_AD_CODE;
(function(ACTIVITY_NOTICE_AD_CODE) {
    ACTIVITY_NOTICE_AD_CODE["INTERN_NOTICE"] = "activity-intern-notice-banner";
    ACTIVITY_NOTICE_AD_CODE["RECRUIT_NOTICE"] = "activity-recruit-notice-banner";
    ACTIVITY_NOTICE_AD_CODE["ACTIVITY_NOTICE"] = "activity-activity-notice-banner";
    ACTIVITY_NOTICE_AD_CODE["CONTEST_NOTICE"] = "activity-contest-notice-banner";
    ACTIVITY_NOTICE_AD_CODE["EDUCATION_NOTICE"] = "activity-education-notice-banner";
})(ACTIVITY_NOTICE_AD_CODE || (ACTIVITY_NOTICE_AD_CODE = {}));
var ACTIVITY_NOTICE_AD_CODE_ID = {
    INTERN_NOTICE: ACTIVITY_NOTICE_AD_CODE.INTERN_NOTICE,
    RECRUIT_NOTICE: ACTIVITY_NOTICE_AD_CODE.RECRUIT_NOTICE,
    ACTIVITY_NOTICE: ACTIVITY_NOTICE_AD_CODE.ACTIVITY_NOTICE,
    CONTEST_NOTICE: ACTIVITY_NOTICE_AD_CODE.CONTEST_NOTICE,
    EDUCATION_NOTICE: ACTIVITY_NOTICE_AD_CODE.EDUCATION_NOTICE
};
var EDUCATION_RECOMMENDATION_AD_CODE_ID = {
    PC: "pc-education-random-banner",
    MOBILE: "mobile-education-random-banner"
};


/***/ }),

/***/ 98693:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BJ": function() { return /* binding */ AD_IMPRESSION_THRESHOLD; },
/* harmony export */   "a0": function() { return /* binding */ TOTAL_AD_SLOTS; },
/* harmony export */   "qe": function() { return /* binding */ TOTAL_ACTIVITY_AD_SLOTS; }
/* harmony export */ });
var AD_IMPRESSION_THRESHOLD = 0.9;
var TOTAL_AD_SLOTS = 4;
var TOTAL_ACTIVITY_AD_SLOTS = 12;


/***/ }),

/***/ 80979:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ ACTIVITY_GTM_EVENT; },
/* harmony export */   "c": function() { return /* binding */ GTM_EVENT; }
/* harmony export */ });
/**
 * 광고 영역별 GTM 이벤트 정의
 */ var GTM_EVENT = {
    MAIN: {
        PC: {
            CLICK_EVENT: "pc_main_list_bnr_clk",
            IMPRESSION_EVENT: "pc_main_list_bnr_imp"
        },
        MOBILE: {
            CLICK_EVENT: "mo_main_list_bnr_clk",
            IMPRESSION_EVENT: "mo_main_list_bnr_imp"
        }
    },
    HOTLINE: {
        PC: {
            CLICK_EVENT: "pc_hotline_bnr_clk",
            IMPRESSION_EVENT: "pc_hotline_bnr_imp"
        },
        MOBILE: {
            CLICK_EVENT: "mo_hotline_bnr_clk",
            IMPRESSION_EVENT: "mo_hotline_bnr_imp"
        }
    },
    RECOMMEND_ACTIVITY_S: {
        PC: {
            CLICK_EVENT: "pc_rec_act_s_bnr_clk",
            IMPRESSION_EVENT: "pc_rec_act_s_bnr_imp"
        },
        MOBILE: {
            CLICK_EVENT: "mo_rec_act_s_bnr_clk",
            IMPRESSION_EVENT: "mo_rec_act_s_bnr_imp"
        }
    },
    RECOMMEND_ACTIVITY_A: {
        PC: {
            CLICK_EVENT: "pc_rec_act_a_bnr_clk",
            IMPRESSION_EVENT: "pc_rec_act_a_bnr_imp"
        },
        MOBILE: {
            CLICK_EVENT: "mo_rec_act_a_bnr_clk",
            IMPRESSION_EVENT: "mo_rec_act_a_bnr_imp"
        }
    },
    WEEKLY_POPULAR: {
        PC: {
            CLICK_EVENT: "pc_wkly_pop_act_clk",
            IMPRESSION_EVENT: "pc_wkly_pop_act_imp"
        },
        MOBILE: {
            CLICK_EVENT: "mo_wkly_pop_act_clk",
            IMPRESSION_EVENT: "mo_wkly_pop_act_imp"
        }
    },
    RECRUIT: {
        PC: {
            CLICK_EVENT: "pc_rec_bnr_clk",
            IMPRESSION_EVENT: "pc_rec_bnr_imp"
        },
        MOBILE: {
            CLICK_EVENT: "mo_rec_bnr_clk",
            IMPRESSION_EVENT: "mo_rec_bnr_imp"
        }
    },
    RIGHT_SIDEBAR: {
        PC: {
            CLICK_EVENT: "pc_rgt_side_all_pg_clk",
            IMPRESSION_EVENT: "pc_rgt_side_all_pg_imp"
        }
    },
    HORIZONTAL: {
        PC: {
            CLICK_EVENT: "pc_horz_ad_clk",
            IMPRESSION_EVENT: "pc_horz_ad_imp"
        }
    },
    RECRUIT_QNA_BOTTOM: {
        PC: {
            CLICK_EVENT: "pc_rec_qna_btm_clk",
            IMPRESSION_EVENT: "pc_rec_qna_btm_imp"
        },
        MOBILE: {
            CLICK_EVENT: "mo_rec_qna_btm_clk",
            IMPRESSION_EVENT: "mo_rec_qna_btm_imp"
        },
        APP: {
            CLICK_EVENT: "app_rec_qna_btm_clk",
            IMPRESSION_EVENT: "app_rec_qna_btm_imp"
        }
    },
    COVER_LETTER_SEARCH: {
        PC: {
            CLICK_EVENT: "pc_cvlt_srch_bnr_clk",
            IMPRESSION_EVENT: "pc_cvlt_srch_bnr_imp"
        },
        MOBILE: {
            CLICK_EVENT: "mo_cvlt_srch_bnr_clk",
            IMPRESSION_EVENT: "mo_cvlt_srch_bnr_imp"
        },
        APP: {
            CLICK_EVENT: "app_cvlt_srch_bnr_clk",
            IMPRESSION_EVENT: "app_cvlt_srch_bnr_imp"
        }
    },
    LIVE_ACTIVITY: {
        PC: {
            CLICK_EVENT: "pc_live_act_clk",
            IMPRESSION_EVENT: "pc_live_act_imp"
        },
        MOBILE: {
            CLICK_EVENT: "mo_live_act_clk",
            IMPRESSION_EVENT: "mo_live_act_imp"
        }
    },
    FULLSCREEN_POPUP: {
        PC: {
            CLICK_EVENT: "pc_full_pop_clk",
            IMPRESSION_EVENT: "pc_full_pop_imp"
        },
        MOBILE: {
            CLICK_EVENT: "mo_full_pop_clk",
            IMPRESSION_EVENT: "mo_full_pop_imp"
        }
    },
    EDUCATION_TOP_PINNED_BANNER: {
        PC: {
            CLICK_EVENT: "pc_edu_top_pinned_bnr_clk",
            IMPRESSION_EVENT: "pc_edu_top_pinned_bnr_imp"
        },
        MOBILE: {
            CLICK_EVENT: "mo_edu_top_pinned_bnr_clk",
            IMPRESSION_EVENT: "mo_edu_top_pinned_bnr_imp"
        },
        APP: {
            IMPRESSION_EVENT: "app_edu_top_pinned_bnr_imp",
            CLICK_EVENT: "app_edu_top_pinned_bnr_clk"
        }
    }
};
var ACTIVITY_GTM_EVENT = {
    INTERN_NOTICE: {
        PC: {
            IMPRESSION_EVENT: "pc_int_ntc_bnr_imp",
            CLICK_EVENT: "pc_int_ntc_bnr_clk"
        },
        MOBILE: {
            IMPRESSION_EVENT: "mo_int_ntc_bnr_imp",
            CLICK_EVENT: "mo_int_ntc_bnr_clk"
        }
    },
    RECRUIT_NOTICE: {
        PC: {
            IMPRESSION_EVENT: "pc_rec_ntc_bnr_imp",
            CLICK_EVENT: "pc_rec_ntc_bnr_clk"
        },
        MOBILE: {
            IMPRESSION_EVENT: "mo_rec_ntc_bnr_imp",
            CLICK_EVENT: "mo_rec_ntc_bnr_clk"
        }
    },
    ACTIVITY_NOTICE: {
        PC: {
            IMPRESSION_EVENT: "pc_act_ntc_bnr_imp",
            CLICK_EVENT: "pc_act_ntc_bnr_clk"
        },
        MOBILE: {
            IMPRESSION_EVENT: "mo_act_ntc_bnr_imp",
            CLICK_EVENT: "mo_act_ntc_bnr_clk"
        }
    },
    CONTEST_NOTICE: {
        PC: {
            IMPRESSION_EVENT: "pc_ctst_ntc_bnr_imp",
            CLICK_EVENT: "pc_ctst_ntc_bnr_clk"
        },
        MOBILE: {
            IMPRESSION_EVENT: "mo_ctst_ntc_bnr_imp",
            CLICK_EVENT: "mo_ctst_ntc_bnr_clk"
        }
    },
    EDUCATION_NOTICE: {
        PC: {
            IMPRESSION_EVENT: "pc_edu_ntc_bnr_imp",
            CLICK_EVENT: "pc_edu_ntc_bnr_clk"
        },
        MOBILE: {
            IMPRESSION_EVENT: "mo_edu_ntc_bnr_imp",
            CLICK_EVENT: "mo_edu_ntc_bnr_clk"
        },
        APP: {
            IMPRESSION_EVENT: "app_edu_ntc_bnr_imp",
            CLICK_EVENT: "app_edu_ntc_bnr_clk"
        }
    }
};


/***/ }),

/***/ 59037:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ RightSideBarBannerStatus_desktop; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(30132);
// EXTERNAL MODULE: ./src/app.components/Skeleton.tsx
var Skeleton = __webpack_require__(96679);
// EXTERNAL MODULE: ./src/app.feature/ad/constants/adCode.ts
var adCode = __webpack_require__(22701);
// EXTERNAL MODULE: ./src/app.feature/ad/hooks/useGetAdByPlacementCodeAndCurrentTime.ts
var useGetAdByPlacementCodeAndCurrentTime = __webpack_require__(68545);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/app.feature/ad/constants/gtm.ts
var gtm = __webpack_require__(80979);
// EXTERNAL MODULE: ./src/app.feature/ad/hooks/useAdImpressionTracker.ts
var useAdImpressionTracker = __webpack_require__(69784);
// EXTERNAL MODULE: ./src/app.feature/ad/modules/gtmEvents.ts
var gtmEvents = __webpack_require__(24033);
// EXTERNAL MODULE: ./src/utils/optimizeImageUrl.ts
var optimizeImageUrl = __webpack_require__(65342);
;// CONCATENATED MODULE: ./src/app.feature/ad/desktop/AllCoverBanner/RightSideBarBanner/RightSideBarBanner.desktop.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 614px;\n  left: calc(100% + 20px);\n  width: 160px;\n  height: 600px;\n  .right-sidebar-banner-image {\n    border-radius: 5px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}








var RIGHT_SIDEBAR_BANNER_PC_IMAGE_SIZE = {
    width: 160,
    height: 600
};
var RightSideBarBannerDesktop = function(param) {
    var ad = param.ad, className = param.className;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    (0,useAdImpressionTracker/* default */.Z)({
        eventName: gtm/* GTM_EVENT.RIGHT_SIDEBAR.PC.IMPRESSION_EVENT */.c.RIGHT_SIDEBAR.PC.IMPRESSION_EVENT,
        campaignId: (ref = ad.campaign) === null || ref === void 0 ? void 0 : ref.id
    });
    var handleClickOutLink = function() {
        var ref, ref1;
        (0,gtmEvents/* pushGTMCampaignId */.h)({
            eventName: gtm/* GTM_EVENT.RIGHT_SIDEBAR.PC.CLICK_EVENT */.c.RIGHT_SIDEBAR.PC.CLICK_EVENT,
            campaignId: ((ref = ad.campaign) === null || ref === void 0 ? void 0 : ref.id) || ""
        });
        if ((ref1 = ad.campaign) === null || ref1 === void 0 ? void 0 : ref1.landingURL) {
            window.open(ad.campaign.landingURL, "_blank", "noopener, noreferrer");
        }
    };
    var activityUrl = ((ref1 = ad.activity) === null || ref1 === void 0 ? void 0 : ref1.id) ? "/activity/".concat((ref2 = ad.activity) === null || ref2 === void 0 ? void 0 : ref2.id) : "";
    var alt = (ad === null || ad === void 0 ? void 0 : (ref3 = ad.campaign) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.campaignGroup) === null || ref4 === void 0 ? void 0 : ref4.name) ? "".concat(ad === null || ad === void 0 ? void 0 : (ref5 = ad.campaign) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.campaignGroup) === null || ref6 === void 0 ? void 0 : ref6.name, " 우측 사이드바 배너 이미지") : "우측 사이드바 배너 이미지";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWrapper, {
        className: className,
        onClick: handleClickOutLink,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            href: activityUrl,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                rel: "nofollow sponsored",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    className: "right-sidebar-banner-image",
                    alt: alt,
                    width: RIGHT_SIDEBAR_BANNER_PC_IMAGE_SIZE.width,
                    height: RIGHT_SIDEBAR_BANNER_PC_IMAGE_SIZE.height,
                    loader: optimizeImageUrl/* imageLoader */.X,
                    src: (0,optimizeImageUrl/* optimizeImageUrl */.m)({
                        url: (ref7 = ad.image) === null || ref7 === void 0 ? void 0 : ref7.url,
                        width: RIGHT_SIDEBAR_BANNER_PC_IMAGE_SIZE.width,
                        height: RIGHT_SIDEBAR_BANNER_PC_IMAGE_SIZE.height
                    })
                }, "right-sidebar-banner-image")
            })
        })
    });
};
/* harmony default export */ var RightSideBarBanner_desktop = (RightSideBarBannerDesktop);
var StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "RightSideBarBanner.desktop__StyledWrapper",
    componentId: "sc-805fd1ed-0"
})(_templateObject());

;// CONCATENATED MODULE: ./src/app.feature/ad/desktop/AllCoverBanner/RightSideBarBanner/RightSideBarBannerStatus.desktop.tsx

function RightSideBarBannerStatus_desktop_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 614px;\n  left: calc(100% + 20px);\n  width: 160px;\n  height: 600px;\n"
    ]);
    RightSideBarBannerStatus_desktop_templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var RightSideBarBannerStatusDesktop = function(param) {
    var className = param.className;
    var ref = (0,useGetAdByPlacementCodeAndCurrentTime/* default */.Z)({
        code: adCode/* PC_AD_CODE.RIGHT_SIDEBAR */.NU.RIGHT_SIDEBAR
    }), ad = ref.ad, loading = ref.loading, error = ref.error;
    if (loading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonWrapper, {
            className: className
        });
    }
    if (error || !ad) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(RightSideBarBanner_desktop, {
        className: className,
        ad: ad
    });
};
/* harmony default export */ var RightSideBarBannerStatus_desktop = (/*#__PURE__*/(0,react.memo)(RightSideBarBannerStatusDesktop));
var SkeletonWrapper = (0,styled_components_browser_esm/* default */.ZP)(Skeleton/* default */.Z).withConfig({
    displayName: "RightSideBarBannerStatus.desktop__SkeletonWrapper",
    componentId: "sc-bcc5720b-0"
})(RightSideBarBannerStatus_desktop_templateObject());


/***/ }),

/***/ 69784:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _modules_gtmEvents__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24033);


/**
 * 광고 impression 이벤트를 추적하는 커스텀 훅
 * 매 렌더링마다 이벤트를 발생시킵니다.
 */ var useAdImpressionTracker = function(param) {
    var eventName = param.eventName, campaignId = param.campaignId;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (campaignId) {
            (0,_modules_gtmEvents__WEBPACK_IMPORTED_MODULE_1__/* .pushGTMCampaignId */ .h)({
                eventName: eventName,
                campaignId: campaignId
            });
        }
    }, []);
};
/* harmony default export */ __webpack_exports__["Z"] = (useAdImpressionTracker);


/***/ }),

/***/ 82138:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var generated_graphql__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47079);
/* harmony import */ var constants_enums__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35460);



var useGetActivityListFromAdsByPlacementCode = function(param) {
    var adPlacementCode = param.adPlacementCode, restVariables = param.restVariables, activityTypeID = param.activityTypeID;
    var noticeBannerQueryVariables = {
        isEducation: activityTypeID === constants_enums__WEBPACK_IMPORTED_MODULE_1__/* .ActivityTypeID.EDUCATION */ .kF.EDUCATION,
        isRecruit: activityTypeID === constants_enums__WEBPACK_IMPORTED_MODULE_1__/* .ActivityTypeID.RECRUIT */ .kF.RECRUIT || activityTypeID === constants_enums__WEBPACK_IMPORTED_MODULE_1__/* .ActivityTypeID.INTERN */ .kF.INTERN,
        isActivity: activityTypeID === constants_enums__WEBPACK_IMPORTED_MODULE_1__/* .ActivityTypeID.ACTIVITY */ .kF.ACTIVITY || activityTypeID === constants_enums__WEBPACK_IMPORTED_MODULE_1__/* .ActivityTypeID.CONTEST */ .kF.CONTEST
    };
    var ref = (0,generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .useGqlActivityListFromAdsByPlacementCodeQuery */ .PTF)({
        variables: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
            adPlacementCode: adPlacementCode
        }, restVariables && restVariables, noticeBannerQueryVariables)
    }), data = ref.data, loading = ref.loading, error = ref.error;
    return {
        ads: data === null || data === void 0 ? void 0 : data.activityListFromAdsByPlacementCode,
        loading: loading,
        error: error
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useGetActivityListFromAdsByPlacementCode);


/***/ }),

/***/ 68545:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var date_fns_format__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32912);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var generated_graphql__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47079);




/**
 * 단일한 랜덤의 광고 지면을 응답받아야 하는 경우 사용합니다.
 * @param  TUseGetAdByPlacementCodeAndCurrentTimeParams
 * @returns
 */ var useGetAdByPlacementCodeAndCurrentTime = function(param) {
    var code = param.code;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var page = router.query.page;
    var currentTime = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        var currentDate = new Date();
        return (0,date_fns_format__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(currentDate, "HH:mm:ss");
    }, [
        page
    ]);
    var ref = (0,generated_graphql__WEBPACK_IMPORTED_MODULE_2__/* .useGqlCurrentAdByPlacementCodeAndCurrentTimeQuery */ .hf9)({
        variables: {
            code: code,
            currentTime: currentTime
        }
    }), data = ref.data, loading = ref.loading, error = ref.error;
    return {
        ad: data === null || data === void 0 ? void 0 : data.currentAdByPlacementCodeAndCurrentTime,
        loading: loading,
        error: error
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useGetAdByPlacementCodeAndCurrentTime);


/***/ }),

/***/ 24033:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ pushGTMCampaignId; }
/* harmony export */ });
/**
 * Campaign ID를 포함한 GTM 이벤트를 발생시키는 함수
 * window.dataLayer가 존재할 경우 이벤트를 push합니다.
 *
 * @param eventName - GTM에서 트리거로 사용될 이벤트 이름
 * @param campaignId - 캠페인 ID
 * @example
 * pushGTMCampaignId({
 *   eventName: 'view_campaign',
 *   campaign_id: '12345'
 * })
 */ var pushGTMCampaignId = function(param) {
    var eventName = param.eventName, campaignId = param.campaignId;
    if (!(window === null || window === void 0 ? void 0 : window.dataLayer) || !campaignId || !eventName) {
        return;
    }
    window.dataLayer.push({
        event: eventName,
        campaign_id: campaignId
    });
};


/***/ }),

/***/ 54554:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(30132);
/* harmony import */ var _app_feature_activityFilter_screen_ModalActivityFilter__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27731);
/* harmony import */ var components_custom_material_ui__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51300);
/* harmony import */ var hooks_useBodyScrollHidden__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(95106);
/* harmony import */ var svgIcons_Slider__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(40380);
/* harmony import */ var _context__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(24600);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    .slider-button-wrapper {\n      position: fixed;\n      bottom: 70px;\n      right: 20px;\n      z-index: 1;\n    }\n\n    .slider-button {\n      width: 50px;\n      height: 50px;\n      background-color: ",
        ";\n      border-radius: 50px;\n      box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.15);\n      font-size: 16px;\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}








var RecruitFilter = function(param) {
    var className = param.className;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isOpen = ref[0], setIsOpen = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(_context__WEBPACK_IMPORTED_MODULE_7__/* .RecruitListScreenContext */ .HR), state = ref1.state, dispatch = ref1.dispatch;
    (0,hooks_useBodyScrollHidden__WEBPACK_IMPORTED_MODULE_5__/* .useBodyScrollHidden */ .v)(isOpen);
    var handleToggleButton = function() {
        setIsOpen(function(prev) {
            return !prev;
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledWrapper, {
        className: className,
        children: [
            !isOpen && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "slider-button-wrapper",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_custom_material_ui__WEBPACK_IMPORTED_MODULE_4__/* .Button */ .zx, {
                    onClick: handleToggleButton,
                    className: "slider-button",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(svgIcons_Slider__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        fontSize: "inherit"
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_app_feature_activityFilter_screen_ModalActivityFilter__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                filterType: "activity",
                activityTypeId: state.activityTypeId,
                onSubmit: function(filterBy) {
                    dispatch({
                        type: "FILTER_BY_SET_ALL",
                        newState: {
                            categoryIDs: filterBy.categoryIDs,
                            jobTypes: filterBy.jobTypes,
                            orgTypeIDs: filterBy.orgTypeIDs,
                            regionIDs: filterBy.regionIDs,
                            internTypeIds: filterBy.internTypeIds,
                            q: filterBy.q
                        }
                    });
                    setIsOpen(false);
                },
                defaultFilterBy: state.filterBy,
                open: isOpen,
                onClose: function() {
                    setIsOpen(false);
                }
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (RecruitFilter);
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "RecruitFilter.mobile__StyledWrapper",
    componentId: "sc-45ac96c0-0"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* .css */ .iv)(_templateObject(), theme.color.primary_2);
});


/***/ }),

/***/ 24090:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ RecruitFilter_pc; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/InputBase/InputBase.js + 1 modules
var InputBase = __webpack_require__(15575);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Collapse/Collapse.js
var Collapse = __webpack_require__(66037);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(30132);
// EXTERNAL MODULE: ./node_modules/use-debounce/esm/useDebouncedCallback.js
var useDebouncedCallback = __webpack_require__(19302);
// EXTERNAL MODULE: ./src/app.feature/jobCategory/store/store.jobCategory.ts + 6 modules
var store_jobCategory = __webpack_require__(76591);
// EXTERNAL MODULE: ./src/components/custom-material-ui/index.ts
var custom_material_ui = __webpack_require__(51300);
// EXTERNAL MODULE: ./src/svgIcons/ExpandMore.tsx
var ExpandMore = __webpack_require__(40934);
// EXTERNAL MODULE: ./src/svgIcons/MagnifyingGlass.tsx
var MagnifyingGlass = __webpack_require__(8741);
// EXTERNAL MODULE: ./src/app.feature/recruitList/context/index.tsx + 3 modules
var context = __webpack_require__(24600);
// EXTERNAL MODULE: ./src/app.modules/hooks/useIsMobile.tsx
var useIsMobile = __webpack_require__(50516);
;// CONCATENATED MODULE: ./src/app.feature/recruitList/hook/useCategoryIdsSyncEffect.ts


var useCategoryIdsSyncEffect = function(params) {
    var getCategoriesByIds = params.getCategoriesByIds, idsByDepth = params.idsByDepth, recruitContext = params.recruitContext, showSelectedIds = params.showSelectedIds;
    var state = recruitContext.state, dispatch = recruitContext.dispatch;
    var isMobile = (0,useIsMobile/* default */.Z)();
    // PC에서 context의 categoryIDs와 jobCategoryStore의 싱크를 맞추기 위함
    return (0,react.useEffect)(function() {
        if (isMobile) {
            return;
        }
        if (idsByDepth[1]) {
            var firstCategories = getCategoriesByIds(idsByDepth[1]);
            var needToggleItems = [];
            firstCategories.map(function(category) {
                var isSelectedInContext = false;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = (state.filterBy.categoryIDs || [])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var categoryId = _step.value;
                        if (categoryId === category.id) {
                            isSelectedInContext = true;
                            break;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                if (isSelectedInContext && !category.isSelect || !isSelectedInContext && category.isSelect) {
                    needToggleItems.push({
                        __typename: "ActivityFilterItemByID",
                        id: category.id,
                        name: category.name
                    });
                }
            });
            needToggleItems.map(function(item) {
                dispatch({
                    type: "FILTER_BY_TOGGLE_FILTER_ITEM",
                    listItem: item,
                    fieldName: "categoryIDs"
                });
            });
        }
    }, [
        showSelectedIds,
        isMobile
    ]);
};
/* harmony default export */ var hook_useCategoryIdsSyncEffect = (useCategoryIdsSyncEffect);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/List/List.js
var List = __webpack_require__(62822);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/ListItem/ListItem.js
var ListItem = __webpack_require__(50998);
// EXTERNAL MODULE: ./src/svgIcons/index.ts + 9 modules
var svgIcons = __webpack_require__(53893);
;// CONCATENATED MODULE: ./src/app.feature/recruitList/component/recruitListFilter/Checkbox.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 16px;\n  height: 16px;\n  border: 1px solid #dddddd;\n  border-radius: 5px;\n  color: white;\n  background-color: white;\n\n  &[data-checked='true'] {\n    background-color: #01a0ff;\n    border: 1px solid #01a0ff;\n  }\n\n  > svg {\n    width: 8px;\n    height: 8px;\n    fill: #fff;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var Checkbox = function(param) {
    var _checked = param.checked, checked = _checked === void 0 ? false : _checked, className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWrapper, {
        "data-checked": checked,
        className: className,
        children: checked && /*#__PURE__*/ (0,jsx_runtime.jsx)(svgIcons/* Check */.Jr, {})
    });
};
/* harmony default export */ var recruitListFilter_Checkbox = (Checkbox);
var StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "Checkbox__StyledWrapper",
    componentId: "sc-a1adfd81-0"
})(_templateObject());

;// CONCATENATED MODULE: ./src/app.feature/recruitList/component/recruitListFilter/RecruitFilterDetailPanel.tsx

function RecruitFilterDetailPanel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: calc(100% - 51px);\n  height: calc(100% - 50px);\n  background-color: #ffffff;\n  position: absolute;\n  top: 50px;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 1;\n  overflow: hidden;\n  ",
        "\n\n  .detail-panel {\n    width: 100%;\n    height: 100%;\n  }\n"
    ]);
    RecruitFilterDetailPanel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var RecruitFilterDetailPanel = function(param) {
    var isClose = param.isClose, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(RecruitFilterDetailPanel_StyledWrapper, {
        isClose: isClose,
        children: children
    });
};
/* harmony default export */ var recruitListFilter_RecruitFilterDetailPanel = (RecruitFilterDetailPanel);
var RecruitFilterDetailPanel_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "RecruitFilterDetailPanel__StyledWrapper",
    componentId: "sc-3db65708-0"
})(RecruitFilterDetailPanel_templateObject(), function(param) {
    var isClose = param.isClose;
    return isClose ? "display: block" : "display: none";
});

;// CONCATENATED MODULE: ./src/app.feature/recruitList/component/recruitListFilter/RecruitFilterItem.pc.tsx

function RecruitFilterItem_pc_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    max-width: ",
        "px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    font-size: 15px;\n    text-align: center;\n    padding: 0;\n    border: 1px solid ",
        ";\n    border-left: 1px solid transparent;\n\n    &:first-child {\n      border-left: 1px solid ",
        ";\n    }\n\n    &.open {\n      background-color: #003056;\n      color: #ffffff;\n    }\n\n    .filter-title {\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      cursor: pointer;\n      padding: 14px 20px;\n      font-size: 14px;\n      text-align: left;\n      font-weight: 500;\n      line-height: 21px;\n\n      .icon-expand-more {\n        transform: rotate(0deg);\n        transition: transform 0.15s ease-in-out;\n\n        &.expanded {\n          transform: rotate(180deg);\n          filter: invert(1);\n        }\n      }\n    }\n\n    .filter-list {\n      width: 100%;\n      height: 254px;\n      position: relative;\n      overflow: hidden;\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n      border-top: 1px solid ",
        ";\n    }\n\n    .filter-scroll {\n      position: absolute;\n      inset: 0;\n      overflow: scroll;\n      margin-right: -15px;\n      margin-bottom: -15px;\n      &::-webkit-scrollbar {\n        -webkit-appearance: none;\n        width: 1px;\n      }\n      &::-webkit-scrollbar-thumb {\n        border-radius: 4px;\n        background-color: none;\n        box-shadow: none;\n        border: none;\n      }\n    }\n\n    .list-item {\n      cursor: pointer;\n      padding: 0 20px;\n      border-bottom: 0;\n\n      &:hover {\n        background-color: ",
        ";\n      }\n\n      .list-title {\n        display: block;\n        width: 100%;\n        color: ",
        ";\n        font-size: 12px;\n        font-weight: 400;\n        height: 21px;\n        line-height: 21px;\n      }\n\n      .item-content {\n        display: flex;\n        height: 42px;\n        flex: 1;\n        align-items: center;\n        border-bottom: 1px solid #eeeeee;\n      }\n\n      .content-checkbox {\n        width: 19px;\n        margin-top: 1px;\n        margin-right: 7px;\n      }\n    }\n  "
    ]);
    RecruitFilterItem_pc_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}










var RecruitFilterItem = function(props) {
    var width = props.width, filterTitle = props.filterTitle, filterItems = props.filterItems, filterKey = props.filterKey, setOpenDetailPanelKey = props.setOpenDetailPanelKey, _isDetailPanelOpen = props.isDetailPanelOpen, isDetailPanelOpen = _isDetailPanelOpen === void 0 ? false : _isDetailPanelOpen, _isHidden = props.isHidden, isHidden = _isHidden === void 0 ? true : _isHidden, DetailPanel = props.DetailPanel, onClickForDetailPanel = props.onClickForDetailPanel, onTitleClick = props.onTitleClick;
    var listDataTestID = "new-activity-list-filter-item-".concat(filterKey);
    var ref = (0,react.useContext)(context/* RecruitListScreenContext */.HR), state = ref.state, dispatch = ref.dispatch;
    var isAllowedDetailPanel = !!onClickForDetailPanel && DetailPanel;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            isAllowedDetailPanel && /*#__PURE__*/ (0,jsx_runtime.jsx)(recruitListFilter_RecruitFilterDetailPanel, {
                isClose: isDetailPanelOpen,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailPanel, {
                    className: "detail-panel",
                    defaultCategoryIds: state.filterBy.categoryIDs
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(RecruitFilterItem_pc_StyledWrapper, {
                className: (0,clsx_m/* default */.Z)({
                    open: isAllowedDetailPanel && isDetailPanelOpen
                }),
                maxWidth: width || 200,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "filter-title",
                        onClick: function() {
                            onTitleClick();
                            setOpenDetailPanelKey(function(prev) {
                                if (prev === filterKey) {
                                    return null;
                                }
                                return filterKey;
                            });
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: filterTitle
                            }),
                            isAllowedDetailPanel && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "/static/images/activity/filter-arrow-icon.svg",
                                className: (0,clsx_m/* default */.Z)("icon-expand-more", {
                                    expanded: isDetailPanelOpen
                                }),
                                alt: "expand-more"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Collapse/* default */.Z, {
                        in: !isHidden,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "filter-list",
                            style: {
                                maxWidth: width
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "filter-scroll",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* default */.Z, {
                                    children: filterItems.map(function(item) {
                                        var key = item.id;
                                        var itemList = state.filterBy[filterKey] || [];
                                        var checked = itemList.includes(key);
                                        var handleClick = function() {
                                            if (isAllowedDetailPanel) {
                                                onClickForDetailPanel && onClickForDetailPanel(item);
                                                setOpenDetailPanelKey(filterKey);
                                                return;
                                            }
                                            dispatch({
                                                type: "FILTER_BY_TOGGLE_FILTER_ITEM",
                                                listItem: item,
                                                fieldName: filterKey
                                            });
                                        };
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem/* default */.Z, {
                                            className: "list-item",
                                            onClick: handleClick,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "item-content",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(recruitListFilter_Checkbox, {
                                                        checked: checked,
                                                        className: "content-checkbox"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                        className: "list-title",
                                                        children: item.name
                                                    })
                                                ]
                                            })
                                        }, key);
                                    })
                                })
                            })
                        }, filterKey)
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var RecruitFilterItem_pc = (RecruitFilterItem);
var RecruitFilterItem_pc_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "RecruitFilterItem.pc__StyledWrapper",
    componentId: "sc-b400e82f-0"
})(_templateObject1(), function(param) {
    var theme = param.theme, maxWidth = param.maxWidth;
    return (0,styled_components_browser_esm/* css */.iv)(RecruitFilterItem_pc_templateObject(), maxWidth, theme.line.line_2, theme.line.line_2, theme.line.line_2, theme.background.bg_3, theme.color.text_2);
});

;// CONCATENATED MODULE: ./src/app.feature/recruitList/component/recruitListFilter/RecruitFilter.pc.tsx


function RecruitFilter_pc_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-grow: 1;\n    position: relative;\n\n    .filter {\n      width: 100%;\n      text-align: left;\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n      font-size: 15px;\n      padding: 0;\n      border: 1px solid ",
        ";\n      border-left: 1px solid transparent;\n\n      &:first-child {\n        border-left: 1px solid ",
        ";\n      }\n\n      .icon-search {\n        margin-right: 5px;\n        font-size: 16px;\n      }\n\n      .organization-name {\n        display: flex;\n        align-items: center;\n        padding: 15px 15px;\n\n        & input[type='text']::-ms-clear {\n          width: 0;\n          height: 0;\n          display: none;\n        }\n      }\n\n      .filter-collapse {\n        height: 254px;\n        background-color: ",
        ";\n        border-top: 1px solid ",
        "};\n      }\n    }\n\n    .filter-button-toggle {\n      width: 100%;\n      max-width: 51px;\n      max-height: 51px;\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n      font-size: 15px;\n      padding: 0;\n      border: 1px solid #102f53;\n\n      .button-toggle {\n        width: 100%;\n        height: 100%;\n        border-radius: 0;\n        background-color: #102f53;\n\n        &:hover {\n          background-color: #102f53e6;\n        }\n\n        .icon-expand-more {\n          fill: white;\n          width:21px;\n          height:21px;\n          transform: rotate(0deg);\n          transition: transform 0.15s ease-out;\n\n          &.expanded {\n            transform: rotate(180deg);\n          }\n        }\n      }\n    }\n  "
    ]);
    RecruitFilter_pc_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function RecruitFilter_pc_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    RecruitFilter_pc_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}















var RecruitFilterPC = function(param) {
    var filterList = param.filterList;
    var ref, ref1;
    var ref2 = (0,react.useState)(false), expanded = ref2[0], setExpanded = ref2[1];
    var ref3 = (0,react.useState)(null), openDetailPanelKey = ref3[0], setOpenDetailPanelKey = ref3[1];
    var toggleExpanded = (0,react.useCallback)(function() {
        setExpanded(!expanded);
    }, [
        expanded
    ]);
    var showExpanded = (0,react.useCallback)(function() {
        setExpanded(true);
    }, []);
    var recruitContext = (0,react.useContext)(context/* RecruitListScreenContext */.HR);
    var state = recruitContext.state, dispatch = recruitContext.dispatch;
    var ref4 = (0,react.useState)((state === null || state === void 0 ? void 0 : (ref = state.filterBy) === null || ref === void 0 ? void 0 : ref.q) || ""), keywordState = ref4[0], setKeywordState = ref4[1];
    var showSelectedIds = (0,store_jobCategory/* default */.Z)(function(state) {
        return state.showSelectedIds;
    });
    var idsByDepth = (0,store_jobCategory/* default */.Z)(function(state) {
        return state.idsByDepth;
    });
    var getCategoriesByIds = (0,store_jobCategory/* default */.Z)(function(state) {
        return state.getCategoriesByIds;
    });
    (0,react.useEffect)(function() {
        var ref;
        setKeywordState((state === null || state === void 0 ? void 0 : (ref = state.filterBy) === null || ref === void 0 ? void 0 : ref.q) || "");
    }, [
        state === null || state === void 0 ? void 0 : (ref1 = state.filterBy) === null || ref1 === void 0 ? void 0 : ref1.q
    ]);
    hook_useCategoryIdsSyncEffect({
        getCategoriesByIds: getCategoriesByIds,
        idsByDepth: idsByDepth,
        showSelectedIds: showSelectedIds,
        recruitContext: recruitContext
    });
    var ref5 = (0,_sliced_to_array/* default */.Z)((0,useDebouncedCallback/* default */.Z)(function(keyword) {
        dispatch({
            type: "FILTER_BY_SET_KEYWORD",
            fieldName: "q",
            listItem: keyword
        });
    }, 800), 1), debounce = ref5[0];
    var handleInputChange = (0,react.useCallback)(function(e) {
        debounce(e.target.value);
        setKeywordState(e.target.value);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(RecruitFilter_pc_StyledWrapper, {
        children: [
            filterList.map(function(param) {
                var filterTitle = param.filterTitle, filterItems = param.filterItems, filterKey = param.filterKey, DetailPanel = param.DetailPanel, itemDetailPanelAction = param.itemDetailPanelAction;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(RecruitFilterItem_pc, {
                    width: 200,
                    filterTitle: filterTitle,
                    filterItems: filterItems,
                    filterKey: filterKey,
                    isHidden: !expanded,
                    isDetailPanelOpen: filterKey === openDetailPanelKey,
                    setOpenDetailPanelKey: setOpenDetailPanelKey,
                    DetailPanel: DetailPanel,
                    onTitleClick: showExpanded,
                    onClickForDetailPanel: itemDetailPanelAction
                }, filterKey);
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "filter",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InputBase/* default */.Z, {
                        margin: "none",
                        placeholder: "공고명, 기업, 직무 검색",
                        inputProps: {
                            style: {
                                padding: 0
                            },
                            "data-testid": "new-activity-list-filter-search-input"
                        },
                        onChange: handleInputChange,
                        value: keywordState,
                        startAdornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(MagnifyingGlass/* default */.Z, {
                            className: "icon-search"
                        }),
                        id: "organizationName",
                        onFocus: showExpanded,
                        className: "organization-name"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Collapse/* default */.Z, {
                        in: expanded,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "filter-collapse"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "filter-button-toggle",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(custom_material_ui/* Button */.zx, {
                    onClick: toggleExpanded,
                    className: "button-toggle",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandMore/* default */.Z, {
                        className: (0,clsx_m/* default */.Z)("icon-expand-more", {
                            expanded: expanded
                        })
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var RecruitFilter_pc = (RecruitFilterPC);
var RecruitFilter_pc_StyledWrapper = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "RecruitFilter.pc__StyledWrapper",
    componentId: "sc-eebf12f0-0"
})(RecruitFilter_pc_templateObject1(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(RecruitFilter_pc_templateObject(), theme.line.line_2, theme.line.line_2, theme.background.bg_3, theme.line.line_2);
});


/***/ }),

/***/ 93168:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30132);
/* harmony import */ var _app_feature_activityFilter_components_SelectedFilterList__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66469);
/* harmony import */ var _RecruitFilterChips_module__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8812);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 8px 0 0 20px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var RecruitFilterChipsMobile = function(props) {
    var filterList = props.filterList, className = props.className;
    var ref = (0,_RecruitFilterChips_module__WEBPACK_IMPORTED_MODULE_3__/* .useRecruitFilterChips */ .f)(filterList), selectedFilterMobileItems = ref.selectedFilterMobileItems, onChipRemoveMobile = ref.onChipRemoveMobile, onReset = ref.onReset;
    if (selectedFilterMobileItems.length === 0) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledWrapper, {
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_app_feature_activityFilter_components_SelectedFilterList__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            items: selectedFilterMobileItems.map(function(item) {
                return {
                    id: item.id,
                    label: item.name,
                    name: item.fieldKey,
                    order: item.order
                };
            }),
            onRemove: function(item) {
                onChipRemoveMobile({
                    fieldKey: item.name,
                    id: item.id,
                    name: item.label
                });
            },
            onReset: onReset
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (RecruitFilterChipsMobile);
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "RecruitFilterChips.mobile__StyledWrapper",
    componentId: "sc-bbd9232e-0"
})(_templateObject());


/***/ }),

/***/ 8812:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ useRecruitFilterChips; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _app_feature_activityFilter_store_storeActivityFilter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86609);
/* harmony import */ var _app_feature_jobCategory_store_store_jobCategory__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76591);
/* harmony import */ var _context__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24600);






var useRecruitFilterChips = function(filterList) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_context__WEBPACK_IMPORTED_MODULE_3__/* .RecruitListScreenContext */ .HR), state = ref.state, dispatch = ref.dispatch;
    var showSelectedIds = (0,_app_feature_jobCategory_store_store_jobCategory__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(state) {
        return state.showSelectedIds;
    });
    var getCategoriesByIds = (0,_app_feature_jobCategory_store_store_jobCategory__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(state) {
        return state.getCategoriesByIds;
    });
    var resetState = (0,_app_feature_jobCategory_store_store_jobCategory__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(state) {
        return state.resetState;
    });
    var getChainingLabelById = (0,_app_feature_jobCategory_store_store_jobCategory__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(state) {
        return state.getChainingLabelById;
    });
    var getOrderByKey = (0,_app_feature_activityFilter_store_storeActivityFilter__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(state) {
        return state.getOrderByKey;
    });
    var selectedCategories = getCategoriesByIds(showSelectedIds);
    var handleReset = function() {
        dispatch({
            type: "FILTER_BY_INIT"
        });
        resetState();
    };
    var handleKeywordDelete = function() {
        dispatch({
            type: "FILTER_BY_SET_KEYWORD",
            listItem: "",
            fieldName: "q"
        });
    };
    var handleChipRemove = function(filterItem) {
        dispatch({
            type: "FILTER_BY_REMOVE_FILTER_ITEM",
            listItem: {
                __typename: "ActivityFilterItemByID",
                id: filterItem.id,
                name: filterItem.name
            },
            fieldName: filterItem.fieldKey
        });
    };
    var handleChipRemoveMobile = function(filterItem) {
        if (filterItem.fieldKey === "q") {
            return handleKeywordDelete();
        }
        handleChipRemove(filterItem);
    };
    var filterByKeys = Object.keys(state.filterBy);
    var selectedFilterItems = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        var result = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var key = _step.value;
                var targetFilter = state.filterBy[key];
                // 기업명의 경우
                if (key === "q" && targetFilter) {
                    result.push({
                        fieldKey: "q",
                        id: "keyword",
                        name: targetFilter,
                        order: 999
                    });
                    return "continue";
                }
                // 직무의 경우
                if (key === "categoryIDs" && Array.isArray(targetFilter)) {
                    targetFilter.map(function(categoryId) {
                        var order = getOrderByKey("categoryIDs.".concat(categoryId));
                        return result.push({
                            fieldKey: "categoryIDs",
                            id: categoryId,
                            name: getChainingLabelById(categoryId),
                            order: order
                        });
                    });
                    return "continue";
                }
                var targetFilterData = filterList.find(function(listItem) {
                    return listItem.filterKey === key;
                });
                if (!targetFilter || !targetFilterData || !Array.isArray(targetFilter)) {
                    return "continue";
                }
                targetFilter.map(function(filterId) {
                    var targetFilterItem = targetFilterData.filterItems.find(function(item) {
                        return item.id === filterId;
                    });
                    if (targetFilterItem) {
                        var order = getOrderByKey("".concat(key, ".").concat(targetFilterItem.id));
                        result.push({
                            fieldKey: key,
                            id: filterId,
                            name: (targetFilterItem === null || targetFilterItem === void 0 ? void 0 : targetFilterItem.name) || "",
                            order: order
                        });
                    }
                    return null;
                });
            };
            for(var _iterator = filterByKeys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return result;
    }, [
        state.filterBy
    ]);
    var selectedFilterPcItems = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        return selectedFilterItems.filter(function(item) {
            return item.fieldKey !== "categoryIDs" && item.fieldKey !== "q";
        });
    }, [
        selectedFilterItems
    ]);
    var selectedFilterMobileItems = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        return selectedFilterItems.map(function(item) {
            if (item.fieldKey !== "categoryIDs") {
                return item;
            }
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, item), {
                name: getChainingLabelById(item.id)
            });
        });
    }, [
        selectedFilterItems
    ]);
    var filterIsEmpty = filterByKeys.reduce(function(acc, cur) {
        var targetFilter = state.filterBy[cur];
        if (Array.isArray(targetFilter)) {
            return acc + (targetFilter === null || targetFilter === void 0 ? void 0 : targetFilter.length) || 0;
        }
        return targetFilter ? acc + 1 : acc;
    }, 0) === 0;
    var keyword = state.filterBy.q;
    return {
        selectedCategories: selectedCategories,
        selectedFilterPcItems: selectedFilterPcItems,
        selectedFilterMobileItems: selectedFilterMobileItems,
        filterIsEmpty: filterIsEmpty,
        keyword: keyword,
        onReset: handleReset,
        onKeywordDelete: handleKeywordDelete,
        onChipRemove: handleChipRemove,
        onChipRemoveMobile: handleChipRemoveMobile
    };
};


/***/ }),

/***/ 41409:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ RecruitFilterChips_pc; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(30132);
// EXTERNAL MODULE: ./src/app.feature/jobCategory/component/selectedItem/index.tsx + 2 modules
var selectedItem = __webpack_require__(8191);
// EXTERNAL MODULE: ./src/components/OldChip.tsx
var OldChip = __webpack_require__(53518);
;// CONCATENATED MODULE: ./src/app.feature/recruitList/component/recruitListFilter/RecruitFilterChip.pc.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 35px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



/**
 * TODO: 2 depth이상 컴포넌트기 때문에 해당 컴포넌트는 추후 수정합니다. 2023.07.05 장선규
 */ var RecruitFilterChipPc = function(param) {
    var fieldKey = param.fieldKey, item = param.item, onClick = param.onClick, _className = param.className, className = _className === void 0 ? "" : _className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWrapper, {
        className: className,
        "data-typeid": "".concat(fieldKey, "-").concat(item.id),
        color: "primary",
        size: "small",
        onDelete: onClick,
        label: item.name
    }, "".concat(fieldKey, "_").concat(item.id));
};
/* harmony default export */ var RecruitFilterChip_pc = (RecruitFilterChipPc);
var StyledWrapper = (0,styled_components_browser_esm/* default */.ZP)(OldChip/* default */.Z).withConfig({
    displayName: "RecruitFilterChip.pc__StyledWrapper",
    componentId: "sc-d16ff2cc-0"
})(_templateObject());

// EXTERNAL MODULE: ./src/app.feature/recruitList/component/recruitListFilter/RecruitFilterChips.module.ts
var RecruitFilterChips_module = __webpack_require__(8812);
;// CONCATENATED MODULE: ./src/app.feature/recruitList/component/recruitListFilter/ResetButton.tsx

function ResetButton_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  color: ",
        ";\n  font-size: 12px;\n  font-weight: 700;\n  opacity: 1;\n  border: none;\n  background-color: transparent;\n  transition: all 0.1s ease-in-out;\n\n  :hover {\n    cursor: pointer;\n    opacity: 0.9;\n  }\n\n  .reset-label {\n    margin-left: 4px;\n  }\n"
    ]);
    ResetButton_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var ResetButton = function(param) {
    var onClick = param.onClick, className = param.className;
    var handleReset = function() {
        onClick && onClick();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledButton, {
        type: "button",
        onClick: handleReset,
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: "/static/images/activity/reset.svg"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "reset-label",
                children: "초기화"
            })
        ]
    });
};
/* harmony default export */ var recruitListFilter_ResetButton = (ResetButton);
var StyledButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    displayName: "ResetButton__StyledButton",
    componentId: "sc-663b6190-0"
})(ResetButton_templateObject(), function(props) {
    return props.theme.color.text_1;
});

;// CONCATENATED MODULE: ./src/app.feature/recruitList/component/recruitListFilter/RecruitFilterChips.pc.tsx

function RecruitFilterChips_pc_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    min-height: 76px;\n    margin-right: 51px;\n    padding: 20px;\n    border: 1px solid ",
        ";\n    border-top: none;\n    display: flex;\n    flex-wrap: wrap;\n    gap: 5px;\n    align-items: center;\n\n    .keyword-chip {\n      height: 35px;\n    }\n\n    .text-empty-helper {\n      font-weight: 500;\n      font-size: 12px;\n      color: ",
        ";\n    }\n  "
    ]);
    RecruitFilterChips_pc_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}







var RecruitFilterChips = function(props) {
    var filterList = props.filterList;
    var ref = (0,RecruitFilterChips_module/* useRecruitFilterChips */.f)(filterList), filterIsEmpty = ref.filterIsEmpty, selectedFilterPcItems = ref.selectedFilterPcItems, selectedCategories = ref.selectedCategories, keyword = ref.keyword, onReset = ref.onReset, onChipRemove = ref.onChipRemove, onKeywordDelete = ref.onKeywordDelete;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(RecruitFilterChips_pc_StyledWrapper, {
        children: [
            selectedFilterPcItems.map(function(item, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(RecruitFilterChip_pc, {
                    fieldKey: item.fieldKey,
                    onClick: function() {
                        onChipRemove(item);
                    },
                    item: item
                }, "selected_filter_chip_".concat(item.id, "_").concat(index));
            }),
            selectedCategories.map(function(category, index) {
                var removeCategoryItem = {
                    fieldKey: "categoryIDs",
                    id: category.id,
                    name: category.name
                };
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(selectedItem/* SelectedItem */.X, {
                    category: category,
                    onDelete: function() {
                        onChipRemove(removeCategoryItem);
                    }
                }, "selected_categories_chip_".concat(category.id, "_").concat(index));
            }),
            keyword && /*#__PURE__*/ (0,jsx_runtime.jsx)(OldChip/* default */.Z, {
                className: "keyword-chip",
                color: "primary",
                size: "small",
                onDelete: onKeywordDelete,
                label: "검색어 - ".concat(keyword)
            }),
            !filterIsEmpty && /*#__PURE__*/ (0,jsx_runtime.jsx)(recruitListFilter_ResetButton, {
                onClick: onReset
            }),
            filterIsEmpty && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-empty-helper",
                children: "상세필터를 선택해 관심있는 공고를 쉽게 찾아보세요."
            })
        ]
    });
};
/* harmony default export */ var RecruitFilterChips_pc = (RecruitFilterChips);
var RecruitFilterChips_pc_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "RecruitFilterChips.pc__StyledWrapper",
    componentId: "sc-deb15898-0"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(RecruitFilterChips_pc_templateObject(), theme.line.line_2, theme.color.text_2);
});


/***/ }),

/***/ 69797:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ recruitListTable_RecruitListTable; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/context.ts + 1 modules
var context = __webpack_require__(52737);
// EXTERNAL MODULE: ./node_modules/graphql-tag/src/index.js
var src = __webpack_require__(44119);
var src_default = /*#__PURE__*/__webpack_require__.n(src);
// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./node_modules/lodash/omitBy.js
var omitBy = __webpack_require__(14176);
var omitBy_default = /*#__PURE__*/__webpack_require__.n(omitBy);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(30132);
// EXTERNAL MODULE: ./src/generated/graphql.ts
var graphql = __webpack_require__(47079);
// EXTERNAL MODULE: ./src/app.feature/jobCategory/store/store.jobCategory.ts + 6 modules
var store_jobCategory = __webpack_require__(76591);
// EXTERNAL MODULE: ./src/constants/enums.ts
var enums = __webpack_require__(35460);
// EXTERNAL MODULE: ./src/app.feature/recruitList/context/index.tsx + 3 modules
var recruitList_context = __webpack_require__(24600);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/query-string/index.js
var query_string = __webpack_require__(17563);
;// CONCATENATED MODULE: ./src/app.feature/recruitList/hook/useRecruitFilterSyncToUrlQuery.tsx



var useRecruitFilterSyncToUrlQuery = function(variables) {
    var router = (0,next_router.useRouter)();
    var urlQueryRef = (0,react.useRef)("");
    (0,react.useEffect)(function() {
        var convertVariableToQuery = function(variables) {
            var filterBy = variables.filterBy, activityOrder = variables.activityOrder, page = variables.page;
            var query = {
                page: page,
                orderBy_direction: activityOrder === null || activityOrder === void 0 ? void 0 : activityOrder.direction,
                orderBy_field: activityOrder === null || activityOrder === void 0 ? void 0 : activityOrder.field
            };
            if (filterBy) {
                Object.keys(filterBy).forEach(function(key) {
                    query["filterBy_".concat(key)] = filterBy[key];
                });
            }
            if (!query) {
                return "";
            }
            var queryString = query_string.stringify(query);
            return queryString;
        };
        var updateUrlQuery = function(queryString) {
            var url = "".concat(router.pathname, "?").concat(queryString);
            router.replace(url, url, {
                shallow: true
            });
        };
        var query = convertVariableToQuery(variables);
        if (query !== urlQueryRef.current) {
            urlQueryRef.current = query;
            updateUrlQuery(query);
        }
    }, [
        variables
    ]);
};
/* harmony default export */ var hook_useRecruitFilterSyncToUrlQuery = (useRecruitFilterSyncToUrlQuery);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Menu/Menu.js + 1 modules
var Menu = __webpack_require__(24794);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/MenuItem/MenuItem.js
var MenuItem = __webpack_require__(85639);
// EXTERNAL MODULE: ./src/components/custom-material-ui/index.ts
var custom_material_ui = __webpack_require__(51300);
// EXTERNAL MODULE: ./src/constants/typeText.ts
var typeText = __webpack_require__(25536);
// EXTERNAL MODULE: ./src/svgIcons/ExpandMore.tsx
var ExpandMore = __webpack_require__(40934);
;// CONCATENATED MODULE: ./src/app.feature/recruitList/component/recruitListTable/component/RecruitListOrderBy.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment RecruitListOrderBy_activityConnection on ActivityConnection {\n    totalCount\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      margin-left: 20px;\n      margin-right: 11px;\n      .search-count-typo {\n        white-space: nowrap;\n        margin-bottom: 12px;\n        font-size: 12px;\n        color: #999;\n      }\n      .button-orderby {\n        padding-top: 10px;\n        padding-bottom: 10px;\n        font-size: 12px;\n      }\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-end;\n    margin-left: 0;\n    margin-right: 0;\n\n    .search-count-typo {\n      font-size: 16px;\n      margin-bottom: 20px;\n      font-weight: 400;\n    }\n    .button-orderby {\n      background-color: transparent;\n      font-weight: 500;\n      &:hover {\n        background-color: transparent;\n      }\n    }\n    .icon-button-end {\n      margin-left: 10px;\n    }\n    .icon-expand-more {\n      width: 14px;\n    }\n\n    ",
        "\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}











src_default()(_templateObject());
var MENU_LIST = [
    graphql/* ActivityOrderField.RECENT */.Ehb.RECENT,
    graphql/* ActivityOrderField.RECRUIT_CLOSE_AT */.Ehb.RECRUIT_CLOSE_AT,
    graphql/* ActivityOrderField.VIEW_COUNT */.Ehb.VIEW_COUNT,
    graphql/* ActivityOrderField.SCRAP_COUNT */.Ehb.SCRAP_COUNT, 
];
var RecruitListOrderBy = function(param) {
    var activityConnection = param.activityConnection;
    var ref;
    var ref1 = (0,react.useState)(null), anchorEl = ref1[0], setAnchorEl = ref1[1];
    var ref2 = (0,react.useContext)(recruitList_context/* RecruitListScreenContext */.HR), state = ref2.state, dispatch = ref2.dispatch;
    var handleClick = function(event) {
        setAnchorEl(event.currentTarget);
    };
    var handleClose = function() {
        setAnchorEl(null);
    };
    var setActivityOrderDirectionByField = function(activityOrderField) {
        switch(activityOrderField){
            case graphql/* ActivityOrderField.RECRUIT_CLOSE_AT */.Ehb.RECRUIT_CLOSE_AT:
                return graphql/* OrderDirection.ASC */.N9t.ASC;
            default:
                return graphql/* OrderDirection.DESC */.N9t.DESC;
        }
    };
    var handleMenuItemClick = function(activityOrderField) {
        dispatch({
            type: "ORDER_BY_UPDATE",
            orderBy: {
                field: activityOrderField,
                direction: setActivityOrderDirectionByField(activityOrderField)
            }
        });
        handleClose();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: "search-count-typo",
                children: [
                    "검색 결과 ",
                    (activityConnection === null || activityConnection === void 0 ? void 0 : activityConnection.totalCount) || "0",
                    "건"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(custom_material_ui/* Button */.zx, {
                className: "button-orderby",
                "aria-controls": "order-menu",
                "aria-haspopup": "true",
                onClick: handleClick,
                classes: {
                    endIcon: "icon-button-end"
                },
                endIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandMore/* default */.Z, {
                    className: "icon-expand-more"
                }),
                children: (state === null || state === void 0 ? void 0 : (ref = state.orderBy) === null || ref === void 0 ? void 0 : ref.field) ? typeText/* ORDER_TEXT */.ID[state.orderBy.field] : ""
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu/* default */.Z, {
                anchorEl: anchorEl,
                keepMounted: true,
                open: Boolean(anchorEl),
                onClose: handleClose,
                children: MENU_LIST.map(function(activityOrderFieldKey) {
                    var ref;
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                        selected: activityOrderFieldKey === (state === null || state === void 0 ? void 0 : (ref = state.orderBy) === null || ref === void 0 ? void 0 : ref.field),
                        onClick: function() {
                            return handleMenuItemClick(activityOrderFieldKey);
                        },
                        children: typeText/* ORDER_TEXT */.ID[activityOrderFieldKey]
                    }, activityOrderFieldKey);
                })
            })
        ]
    });
};
/* harmony default export */ var component_RecruitListOrderBy = (RecruitListOrderBy);
var StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "RecruitListOrderBy__StyledWrapper",
    componentId: "sc-c4d6f9e4-0"
})(_templateObject3(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject2(), theme.isMobile && (0,styled_components_browser_esm/* css */.iv)(_templateObject1()));
});

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(63457);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/useTheme.js
var useTheme = __webpack_require__(8920);
// EXTERNAL MODULE: ./node_modules/lodash/isNumber.js
var isNumber = __webpack_require__(81763);
var isNumber_default = /*#__PURE__*/__webpack_require__.n(isNumber);
// EXTERNAL MODULE: ./src/components/Pagination.tsx
var Pagination = __webpack_require__(83740);
// EXTERNAL MODULE: ./src/constants/paginations.ts
var paginations = __webpack_require__(52169);
// EXTERNAL MODULE: ./src/hooks/usePagination.ts
var usePagination = __webpack_require__(27914);
;// CONCATENATED MODULE: ./src/app.feature/recruitList/component/recruitListTable/component/RecruitListPagination.tsx









var PAGE_SIZE = 20;
var RecruitListPagination = function(param) {
    var totalCount = param.totalCount;
    var setActivePage = function setActivePage(newActivePage) {
        // @ts-ignore
        dispatch({
            type: "PAGE_UPDATE",
            page: newActivePage
        });
    };
    var theme = (0,useTheme/* default */.Z)();
    var isSMDown = (0,useMediaQuery/* default */.Z)(theme.breakpoints.down("sm"));
    var ref = (0,react.useContext)(recruitList_context/* RecruitListScreenContext */.HR), state = ref.state, dispatch = ref.dispatch;
    var pagination = (0,usePagination/* default */.Z)({
        activePage: state.page || 1,
        setActivePage: setActivePage,
        maxButtons: isSMDown ? paginations/* MOBILE_BUTTON_SIZE */.zw : paginations/* PC_BUTTON_SIZE */.lW,
        scrollToTop: true
    });
    (0,react.useEffect)(function() {
        if (isNumber_default()(totalCount)) {
            pagination.setNumberOfPages(Math.ceil(totalCount / PAGE_SIZE));
            window.scrollTo(0, 0);
        }
    }, [
        totalCount,
        state.page
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Pagination/* default */.Z, {
        pagination: pagination
    });
};
/* harmony default export */ var component_RecruitListPagination = (RecruitListPagination);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./src/app.feature/ad/constants/adCode.ts
var adCode = __webpack_require__(22701);
// EXTERNAL MODULE: ./src/app.feature/ad/constants/constants.ts
var constants = __webpack_require__(98693);
// EXTERNAL MODULE: ./src/app.feature/ad/hooks/useGetActivityListFromAdsByPlacementCode.ts
var useGetActivityListFromAdsByPlacementCode = __webpack_require__(82138);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/format/index.js + 3 modules
var format = __webpack_require__(32912);
// EXTERNAL MODULE: ./node_modules/lodash/take.js
var take = __webpack_require__(69572);
var take_default = /*#__PURE__*/__webpack_require__.n(take);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./src/app.feature/recruitList/module/extractInternTypesName.ts

var extractInternTypesName = function(param) {
    var internTypesCount = param.internTypesCount, activity = param.activity;
    if (internTypesCount === 1) {
        var ref, ref1, ref2, ref3;
        return ((ref1 = activity === null || activity === void 0 ? void 0 : (ref = activity.recruitInformations) === null || ref === void 0 ? void 0 : ref.find(function(info) {
            return (info === null || info === void 0 ? void 0 : info.jobType) === graphql/* JobType.INTERN */.O4l.INTERN;
        })) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.internTypes) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[0]) === null || ref3 === void 0 ? void 0 : ref3.name) || "";
    } else {
        return "인턴";
    }
};

// EXTERNAL MODULE: ./src/app.feature/recruitList/module/getAddressesText.ts
var getAddressesText = __webpack_require__(99308);
// EXTERNAL MODULE: ./src/app.modules/hooks/useIsWebview.tsx
var useIsWebview = __webpack_require__(67235);
// EXTERNAL MODULE: ./src/app.modules/util/index.tsx
var util = __webpack_require__(65677);
// EXTERNAL MODULE: ./src/app.constants/recruitImageSize.ts
var recruitImageSize = __webpack_require__(49770);
// EXTERNAL MODULE: ./src/components/ActivityScrap.tsx
var ActivityScrap = __webpack_require__(91202);
// EXTERNAL MODULE: ./src/components/Link.tsx
var Link = __webpack_require__(34557);
// EXTERNAL MODULE: ./src/svgIcons/BookMark.tsx
var BookMark = __webpack_require__(49123);
// EXTERNAL MODULE: ./src/utils/optimizeImageUrl.ts
var optimizeImageUrl = __webpack_require__(65342);
// EXTERNAL MODULE: ./src/utils/utils.ts
var utils = __webpack_require__(55208);
// EXTERNAL MODULE: ./src/app.feature/recruitList/module/index.ts + 2 modules
var recruitList_module = __webpack_require__(2226);
// EXTERNAL MODULE: ./src/app.components/Skeleton.tsx
var Skeleton = __webpack_require__(96679);
;// CONCATENATED MODULE: ./src/app.feature/recruitList/component/recruitListTable/component/desktop/component/ActivityTableRowLoading.desktop.tsx

function ActivityTableRowLoading_desktop_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    background-color: ",
        ";\n\n    .item-recruit-company {\n      height: 100%;\n      display: flex;\n      align-items: center;\n      padding-left: 20px;\n\n      .image-skeleton {\n        margin-right: 20px;\n      }\n    }\n\n    .item-recruit-name,\n    .item-recruit-type,\n    .item-location,\n    .item-recruit-close,\n    .item-view-count,\n    .item-button-scrap {\n      width: 100%;\n      height: 100%;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      padding: 10px 0;\n    }\n\n    .item-recruit-name {\n      justify-content: flex-start;\n      padding-right: 20px;\n    }\n\n    .recruit-link {\n      width: 100%;\n    }\n\n    .recruit-category-skeleton {\n      margin-top: 5px;\n    }\n  "
    ]);
    ActivityTableRowLoading_desktop_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ActivityTableRowLoading_desktop_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    ActivityTableRowLoading_desktop_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var ActivityTableRowLoading = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledLoadingWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "item-recruit-company",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                            width: 60,
                            height: 60,
                            className: "image-skeleton"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                            width: 100,
                            height: 10
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "item-recruit-name",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "recruit-link",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "recruit-name-container",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                    width: 72,
                                    height: 16
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                width: 200,
                                height: 10,
                                className: "recruit-category-skeleton"
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "item-recruit-type",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                        width: "5em",
                        height: 10
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "item-location",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                        width: "5em",
                        height: 10
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "item-recruit-close",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                        width: 72,
                        height: 10
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "item-view-count",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                        width: 50,
                        height: 10
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "item-button-scrap",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                        width: 32,
                        height: 21
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var ActivityTableRowLoading_desktop = (ActivityTableRowLoading);
var StyledLoadingWrapper = styled_components_browser_esm/* default.tr.withConfig */.ZP.tr.withConfig({
    displayName: "ActivityTableRowLoading.desktop__StyledLoadingWrapper",
    componentId: "sc-c6ff9ee3-0"
})(ActivityTableRowLoading_desktop_templateObject1(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(ActivityTableRowLoading_desktop_templateObject(), theme.background.bg_8);
});

;// CONCATENATED MODULE: ./src/app.feature/recruitList/component/recruitListTable/component/desktop/component/ActivityTableRow.desktop.tsx


function ActivityTableRow_desktop_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment ActivityTableRow_currentUser on User {\n    ...ActivityScrap_currentUser\n  }\n  fragment ActivityTableRow_activity on Activity {\n    id\n    type\n    isScrapped\n    title\n    jobTypes\n    recruitInformations {\n      id\n      jobType\n      internTypes {\n        id\n        name\n      }\n    }\n    recruitType\n    recruitScale\n    organizationName\n    recruitCloseAt\n    viewCount\n    logoImage {\n      id\n      url\n    }\n    categories {\n      id\n      name\n    }\n    regions {\n      id\n      name\n    }\n    regionDistricts {\n      id\n      name\n      region {\n        id\n        name\n      }\n    }\n    addresses {\n      address\n      bcode\n      bname\n      detailAddress\n      id\n      isAbroad\n      isPossibleWorkingFromHome\n      sido\n      sigungu\n      sigunguCode\n      zoneCode\n    }\n    ...ActivityScrap_activity\n  }\n"
    ]);
    ActivityTableRow_desktop_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ActivityTableRow_desktop_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    background-color: #ffffff;\n\n    .item-recruit-company {\n      height: 100%;\n      display: flex;\n      align-items: center;\n      padding-left: 20px;\n      cursor: ",
        ";\n\n      .company-thumb {\n        width: 60px;\n        height: 60px;\n        margin-right: 20px;\n        flex-shrink: 0;\n      }\n\n      .company-name {\n        font-size: 16px;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        text-align: left;\n        font-weight: 300;\n        color: ",
        ";\n      }\n    }\n\n    .item-recruit-name {\n      width: 100%;\n      height: 100%;\n      display: flex;\n      align-items: center;\n\n      .recruit-link {\n        width: 100%;\n\n        &:hover {\n          .recommend-text,\n          .recruit-name,\n          .recruit-category {\n            text-decoration: underline;\n          }\n        }\n\n        .recruit-name-container {\n          display: flex;\n\n          .recommend-tag-container {\n            display: flex;\n            padding: 2px;\n            border: 1px solid #ff0066;\n            border-radius: 3px;\n            margin-right: 5px;\n            flex-shrink: 0;\n            height: 100%;\n\n            .recommend-text {\n              color: ",
        ";\n              font-size: 11px;\n            }\n          }\n\n          .recruit-name {\n            font-size: 16px;\n            color: ",
        ";\n            line-height: 1.2em;\n            white-space: pre-wrap;\n            font-weight: 500;\n            letter-spacing: -0.6px;\n            overflow: hidden;\n            text-overflow: ellipsis;\n            text-align: left;\n          }\n        }\n\n        .recruit-category {\n          max-width: 270px;\n          height: 24px;\n          font-size: 16px;\n          color: ",
        ";\n          line-height: 24px;\n          white-space: nowrap;\n          overflow: hidden;\n          text-overflow: ellipsis;\n          text-align: left;\n          font-weight: 400;\n        }\n      }\n    }\n\n    .item-recruit-type,\n    .item-location,\n    .item-recruit-close,\n    .item-view-count {\n      width: 100%;\n      height: 100%;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n\n      .short-info-typo {\n        font-size: 16px;\n        color: ",
        ";\n        white-space: nowrap;\n        letter-spacing: -0.6px;\n        line-height: 1.5;\n        font-weight: 400;\n        text-overflow: ellipsis;\n        text-align: center;\n        overflow: hidden;\n        padding: 0 1px;\n      }\n    }\n\n    .item-button-scrap {\n      width: 100%;\n      height: 100%;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n\n      .button-scrap {\n        height: 21px;\n        color: ",
        ";\n        border: 0;\n        background-color: transparent;\n        overflow: visible;\n        font-size: 1.5rem;\n        text-align: center;\n        padding: 12px 12px 0;\n        transition: background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n        cursor: pointer;\n\n        .icon-bookmark {\n          color: #01a0ff;\n          width: 15px;\n        }\n      }\n\n      .short-info-typo {\n        font-size: 16px;\n        color: ",
        ";\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        text-align: center;\n        font-weight: 400;\n        line-height: 1.5;\n        letter-spacing: -0.6px;\n\n        &.scrapped {\n          color: ",
        ";\n        }\n      }\n    }\n  "
    ]);
    ActivityTableRow_desktop_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ActivityTableRow_desktop_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    ActivityTableRow_desktop_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}























src_default()(ActivityTableRow_desktop_templateObject());
var ActivityTableRow = function(props) {
    var ref, ref1, ref2, ref3, ref4;
    var _className = props.className, className = _className === void 0 ? "" : _className, isLoading = props.isLoading, activity = props.activity, currentUser = props.currentUser, isRecommend = props.isRecommend, onClick = props.onClick;
    var router = (0,next_router.useRouter)();
    var isWebview = (0,useIsWebview/* default */.Z)();
    var state = (0,react.useContext)(recruitList_context/* RecruitListScreenContext */.HR).state;
    if (isLoading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ActivityTableRowLoading_desktop, {});
    }
    var handleClickOrganization = function() {
        var ref;
        if (activity === null || activity === void 0 ? void 0 : (ref = activity.manager) === null || ref === void 0 ? void 0 : ref.channel) {
            router.push((0,util/* getWebviewHref */.ys)("/channel/".concat(activity.manager.channel.url), isWebview));
        }
    };
    var isIntern = router.pathname.includes("intern") || ((ref = state.filterBy.jobTypes) === null || ref === void 0 ? void 0 : ref.includes(graphql/* JobType.INTERN */.O4l.INTERN));
    var categoriesText = (0,recruitList_module/* getCategoriesText */.f6)(activity === null || activity === void 0 ? void 0 : activity.categories);
    var viewCount = (0,recruitList_module/* getViewCount */.uF)((activity === null || activity === void 0 ? void 0 : activity.viewCount) || 0);
    var regionsText = (0,recruitList_module/* getRegionsText */.G5)(activity === null || activity === void 0 ? void 0 : activity.regionDistricts, activity === null || activity === void 0 ? void 0 : activity.regions);
    var ref5;
    var addressesText = (0,getAddressesText/* getAddressesText */.l)((ref5 = activity === null || activity === void 0 ? void 0 : activity.addresses) !== null && ref5 !== void 0 ? ref5 : []);
    var imageUrl = (activity === null || activity === void 0 ? void 0 : (ref1 = activity.logoImage) === null || ref1 === void 0 ? void 0 : ref1.url) || "";
    var internTypesCount = activity === null || activity === void 0 ? void 0 : activity.recruitInformations.map(function(info) {
        var _length;
        return (_length = info === null || info === void 0 ? void 0 : info.internTypes.length) !== null && _length !== void 0 ? _length : 0;
    }).reduce(function(accumulator, currentValue) {
        return accumulator + currentValue;
    }, 0);
    var _obj;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ActivityTableRow_desktop_StyledWrapper, {
        className: className,
        isCursorPointer: !!((activity === null || activity === void 0 ? void 0 : (ref2 = activity.manager) === null || ref2 === void 0 ? void 0 : ref2.channel) !== undefined && (activity === null || activity === void 0 ? void 0 : (ref3 = activity.manager) === null || ref3 === void 0 ? void 0 : ref3.channel) !== null),
        "data-activityid": activity === null || activity === void 0 ? void 0 : activity.id,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "item-recruit-company",
                    onClick: handleClickOrganization,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "company-thumb",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                loader: optimizeImageUrl/* imageLoader */.X,
                                height: recruitImageSize/* RECRUIT_LOGO_IMAGE_SIZE */.XM,
                                width: recruitImageSize/* RECRUIT_LOGO_IMAGE_SIZE */.XM,
                                alt: (activity === null || activity === void 0 ? void 0 : activity.title) || "",
                                src: (0,optimizeImageUrl/* optimizeImageUrl */.m)({
                                    url: imageUrl,
                                    width: "auto",
                                    height: recruitImageSize/* RECRUIT_LOGO_IMAGE_SIZE */.XM
                                }),
                                quality: 100,
                                objectFit: "contain"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "company-name",
                            children: activity === null || activity === void 0 ? void 0 : activity.organizationName
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "item-recruit-name",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* default */.Z, {
                        className: "recruit-link",
                        href: "/activity/[id]",
                        target: "_blank",
                        as: "/activity/".concat(activity === null || activity === void 0 ? void 0 : activity.id),
                        naked: true,
                        onClick: function() {
                            onClick && onClick();
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "recruit-name-container",
                                children: [
                                    isRecommend && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "recommend-tag-container",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "recommend-text",
                                            children: "추천"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "recruit-name",
                                        children: activity === null || activity === void 0 ? void 0 : activity.title
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "recruit-category",
                                children: categoriesText
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "item-recruit-type",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: isIntern ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "short-info-typo",
                            children: extractInternTypesName({
                                internTypesCount: internTypesCount,
                                activity: activity
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "short-info-typo",
                            children: (activity === null || activity === void 0 ? void 0 : (ref4 = activity.jobTypes) === null || ref4 === void 0 ? void 0 : ref4.length) ? (0,utils/* getJobType */.ob)(take_default()(activity.jobTypes, 2)) : "-"
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "item-location",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "short-info-typo",
                        children: (activity === null || activity === void 0 ? void 0 : activity.addresses) && (activity === null || activity === void 0 ? void 0 : activity.addresses.length) >= 1 ? addressesText : regionsText
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "item-recruit-close",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "short-info-typo",
                        children: (activity === null || activity === void 0 ? void 0 : activity.recruitType) ? (_obj = {}, (0,_define_property/* default */.Z)(_obj, graphql/* ActivityRecruitType.NORMAL */.iS2.NORMAL, (activity === null || activity === void 0 ? void 0 : activity.recruitCloseAt) ? "~ ".concat((0,format/* default */.Z)(new Date(activity.recruitCloseAt), "MM.dd")) : "-"), (0,_define_property/* default */.Z)(_obj, graphql/* ActivityRecruitType.ALWAYS */.iS2.ALWAYS, "상시채용"), (0,_define_property/* default */.Z)(_obj, graphql/* ActivityRecruitType.ASAP */.iS2.ASAP, "채용 시 마감"), (0,_define_property/* default */.Z)(_obj, graphql/* ActivityRecruitType.SCHEDULED */.iS2.SCHEDULED, "예정"), _obj)[activity.recruitType] : "-"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "item-view-count",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "short-info-typo",
                        children: viewCount
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "item-button-scrap",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ActivityScrap/* default */.Z, {
                            activity: activity,
                            currentUser: currentUser,
                            children: function(param) {
                                var scrapActivity = param.scrapActivity, loading = param.loading, scrapCount = param.scrapCount;
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            onClick: scrapActivity,
                                            className: "button-scrap",
                                            disabled: loading,
                                            "aria-label": "스크랩하기",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BookMark/* default */.Z, {
                                                className: "icon-bookmark",
                                                isOn: activity === null || activity === void 0 ? void 0 : activity.isScrapped,
                                                strokeType: "#666666"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: (0,clsx_m/* default */.Z)("short-info-typo", {
                                                scrapped: activity === null || activity === void 0 ? void 0 : activity.isScrapped
                                            }),
                                            children: scrapCount
                                        })
                                    ]
                                });
                            }
                        })
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var ActivityTableRow_desktop = (ActivityTableRow);
var ActivityTableRow_desktop_StyledWrapper = styled_components_browser_esm/* default.tr.withConfig */.ZP.tr.withConfig({
    displayName: "ActivityTableRow.desktop__StyledWrapper",
    componentId: "sc-37c35659-0"
})(ActivityTableRow_desktop_templateObject2(), function(param) {
    var theme = param.theme, isCursorPointer = param.isCursorPointer;
    return (0,styled_components_browser_esm/* css */.iv)(ActivityTableRow_desktop_templateObject1(), isCursorPointer && "pointer", theme.color.text_1, theme.color.secondary_1, theme.color.text_1, theme.color.text_3, theme.color.text_1, theme.line.line_3, theme.color.text_3, theme.color.primary_2);
});

;// CONCATENATED MODULE: ./src/app.feature/recruitList/component/recruitListTable/component/desktop/component/RecruitListItem.desktop.tsx

function RecruitListItem_desktop_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment RecruitListItem_currentUser on User {\n    id\n    ...ActivityTableRow_currentUser\n    ...ActivityListItem_currentUser\n  }\n  fragment RecruitListItem_activity on Activity {\n    id\n    ...ActivityTableRow_activity\n    ...ActivityListItem_activity\n  }\n"
    ]);
    RecruitListItem_desktop_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



src_default()(RecruitListItem_desktop_templateObject());
var RecruitListItemDesktop = function(props) {
    var isLoading = props.isLoading, activity = props.activity, currentUser = props.currentUser, isRecommend = props.isRecommend, onClick = props.onClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ActivityTableRow_desktop, {
        className: "activity-table-row",
        currentUser: currentUser,
        activity: activity,
        isLoading: isLoading,
        isRecommend: isRecommend,
        onClick: onClick
    });
};
/* harmony default export */ var RecruitListItem_desktop = (RecruitListItemDesktop);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/CircularProgress/CircularProgress.js
var CircularProgress = __webpack_require__(95477);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/IconButton/IconButton.js
var IconButton = __webpack_require__(17812);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./src/app.feature/recruitList/module/getViewCount.ts
var getViewCount = __webpack_require__(79445);
// EXTERNAL MODULE: ./src/components/OldChip.tsx
var OldChip = __webpack_require__(53518);
// EXTERNAL MODULE: ./src/hooks/useKeywordHighlighter.ts
var useKeywordHighlighter = __webpack_require__(17683);
;// CONCATENATED MODULE: ./src/app.feature/recruitList/component/recruitListTable/component/mobile/component/ActivityListItem.mobile.tsx




function ActivityListItem_mobile_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment ActivityListItem_currentUser on User {\n    ...ActivityScrap_currentUser\n  }\n"
    ]);
    ActivityListItem_mobile_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ActivityListItem_mobile_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    background-color: #ffffff;\n    padding: 15px 10px 15px 20px;\n    display: none;\n    align-items: center;\n    position: relative;\n\n    &::after {\n      content: '';\n      height: 1px;\n      width: calc(100% - 40px);\n      background-color: #eeeeee;\n      display: block;\n      position: absolute;\n      bottom: 0;\n    }\n\n    ",
        " {\n      padding-left: 0;\n    }\n\n    ",
        " {\n      display: flex;\n    }\n\n    &.large {\n      padding-top: 20px;\n      padding-bottom: 20px;\n\n      ",
        " {\n        padding-top: 15px;\n        padding-bottom: 15px;\n      }\n    }\n\n    .img-wrapper {\n      width: 60px;\n      flex-shrink: 0;\n      display: flex;\n      align-items: center;\n      margin-right: 15px;\n\n      .img-thumbnail {\n        & img {\n          border-radius: 5px;\n        }\n      }\n    }\n\n    .recruit-content {\n      min-width: 0;\n      display: flex;\n      align-items: center;\n      flex-grow: 1;\n\n      .content-wrapper {\n        min-width: 0;\n        max-width: 100%;\n        display: flex;\n        flex-direction: column;\n        align-items: flex-start;\n        flex-grow: 1;\n        margin-right: 30px;\n\n        .organization-wrapper {\n          width: 100%;\n          flex-grow: 0;\n          flex-shrink: 0;\n          margin-right: 30px;\n          margin-bottom: 4px;\n          display: flex;\n          align-items: center;\n\n          .container {\n            width: 100%;\n            display: flex;\n            align-items: center;\n\n            .recommand-tag-container {\n              width: 25px;\n              height: 20px;\n              display: flex;\n              align-items: center;\n              justify-content: center;\n              flex-shrink: 0;\n              border-radius: 3px;\n              border: 1px solid #ff0066;\n              background-color: white;\n              margin-right: 5px;\n              box-sizing: content-box;\n            }\n\n            .recommand-text {\n              color: ",
        ";\n              font-size: 11px;\n              font-weight: 500;\n              line-height: 10px;\n            }\n          }\n\n          .chip {\n            background-color: #bbbbbb;\n            border: 0;\n            border-radius: 3px;\n            margin-right: 5px;\n            height: auto;\n          }\n\n          .hot {\n            background-image: #ef2929;\n          }\n\n          .label {\n            line-height: 1em;\n            font-size: 12px;\n            padding: 3px;\n            color: #ffffff;\n            font-weight: 500;\n          }\n\n          .organization-name {\n            width: 100%;\n            font-size: 12px;\n            white-space: nowrap;\n            overflow: hidden;\n            text-overflow: ellipsis;\n            text-align: left;\n            font-weight: 500;\n          }\n        }\n      }\n    }\n\n    .recruit-title {\n      width: 100%;\n      flex-grow: 1;\n      margin-right: 30px;\n      margin-bottom: 4px;\n\n      .link {\n        &:hover {\n          text-decoration: underline;\n        }\n\n        .title {\n          font-size: 16px;\n          white-space: pre-wrap;\n          overflow: hidden;\n          text-overflow: ellipsis;\n          line-height: 1.2em;\n          text-align: left;\n          display: -webkit-box;\n          -webkit-line-clamp: 1;\n          -webkit-box-orient: vertical;\n\n          & .highlight {\n            font-weight: 600;\n          }\n        }\n      }\n    }\n\n    .info-wrapper-recruit {\n      display: flex;\n      align-items: center;\n      max-width: 100%;\n      flex-shrink: 0;\n      flex-wrap: wrap;\n\n      .first-container,\n      .second-container {\n        display: flex;\n\n        .job-type-container {\n          margin-right: 0;\n        }\n\n        .category-container {\n          flex-grow: 1;\n          display: flex;\n\n          .category {\n            font-size: 12px;\n            white-space: nowrap;\n            overflow: hidden;\n            text-overflow: ellipsis;\n            text-align: left;\n            font-weight: 400;\n            padding-right: 10px;\n          }\n        }\n\n        .short-info-typo {\n          font-size: 12px;\n          white-space: nowrap;\n          overflow: hidden;\n          text-overflow: ellipsis;\n          text-align: left;\n          font-weight: 400;\n          padding-right: 10px;\n        }\n\n        .view-count {\n          margin-left: 0;\n        }\n      }\n    }\n\n    .info-wrapper-other {\n      max-width: 100%;\n      display: flex;\n      align-items: center;\n      flex-shrink: 0;\n\n      .skeleton-wrapper {\n        margin-right: 8px;\n      }\n\n      .short-info-typo {\n        font-size: 12px;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        text-align: left;\n        font-weight: 400;\n        padding-right: 10px;\n      }\n\n      .view-count {\n        margin-left: 0;\n      }\n    }\n\n    .scrap-container {\n      flex-shrink: 0;\n\n      .button-scrap {\n        color: #e8e8e8;\n        padding-bottom: 5px;\n\n        @media (hover: hover) and (pointer: fine) {\n          &:hover {\n            color: ",
        ";\n          }\n        }\n\n        &.scrapped {\n          color: ",
        ";\n        }\n      }\n\n      .scrap-count-skeleton {\n        margin: auto;\n      }\n\n      .scrap-count {\n        color: ",
        ";\n        font-size: 12px;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        text-align: center;\n\n        &.scrapped {\n          color: ",
        ";\n        }\n      }\n\n      .icon-bookmark {\n        width: 15px;\n        height: 15px;\n      }\n    }\n\n    .dot {\n      font-size: 12px;\n      font-weight: 300;\n      margin-left: 5px;\n      margin-right: 5px;\n    }\n  "
    ]);
    ActivityListItem_mobile_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ActivityListItem_mobile_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    ActivityListItem_mobile_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}





























src_default()(ActivityListItem_mobile_templateObject());
var ActivityListItem = function(props) {
    var renderSecondary = function renderSecondary() {
        if (isRecruit) {
            var ref;
            var categoriesText = "-";
            if (categories.length > 1) {
                categoriesText = "각 부문";
            } else if (categories.length === 1 && categories[0]) {
                categoriesText = categories[0];
            }
            var _obj;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "info-wrapper-recruit",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "first-container",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "job-type-container",
                                children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                    height: 13
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: isIntern ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "short-info-typo",
                                        children: extractInternTypesName({
                                            internTypesCount: internTypesCount,
                                            activity: activity
                                        })
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "short-info-typo",
                                        children: (activity === null || activity === void 0 ? void 0 : (ref = activity.jobTypes) === null || ref === void 0 ? void 0 : ref.length) ? (0,utils/* getJobType */.ob)(take_default()(activity.jobTypes, 2)) : "-"
                                    })
                                })
                            }),
                            isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                height: 13,
                                width: 100
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "category-container",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "category",
                                    children: categoriesText
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "second-container",
                        children: [
                            isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                height: 13
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "short-info-typo",
                                children: (activity === null || activity === void 0 ? void 0 : activity.recruitType) ? (_obj = {}, (0,_define_property/* default */.Z)(_obj, graphql/* ActivityRecruitType.NORMAL */.iS2.NORMAL, (activity === null || activity === void 0 ? void 0 : activity.recruitCloseAt) ? "~ ".concat((0,format/* default */.Z)(new Date(activity.recruitCloseAt), "MM.dd")) : "-"), (0,_define_property/* default */.Z)(_obj, graphql/* ActivityRecruitType.ALWAYS */.iS2.ALWAYS, "상시채용"), (0,_define_property/* default */.Z)(_obj, graphql/* ActivityRecruitType.ASAP */.iS2.ASAP, "채용 시 마감"), (0,_define_property/* default */.Z)(_obj, graphql/* ActivityRecruitType.SCHEDULED */.iS2.SCHEDULED, "예정"), _obj)[activity.recruitType] : "-"
                            }),
                            isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                height: 13
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "short-info-typo",
                                children: [
                                    "조회 ",
                                    viewCount
                                ]
                            })
                        ]
                    })
                ]
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "info-wrapper-other",
            children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "skeleton-wrapper",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                            width: 40,
                            height: 13
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                        width: 40,
                        height: 13
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "short-info-typo",
                        children: (activity === null || activity === void 0 ? void 0 : activity.recruitCloseAt) ? (0,format/* default */.Z)(activity.recruitCloseAt, "~M.dd") : "-"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: (0,clsx_m/* default */.Z)("short-info-typo", "view-count"),
                        children: [
                            "조회 ",
                            viewCount
                        ]
                    })
                ]
            })
        });
    };
    var ref, ref1, ref2, ref3, ref4, ref5;
    var router = (0,next_router.useRouter)();
    var isWebview = (0,useIsWebview/* default */.Z)();
    var state = (0,react.useContext)(recruitList_context/* RecruitListScreenContext */.HR).state;
    var _className = props.className, className = _className === void 0 ? "" : _className, _size = props.size, size = _size === void 0 ? "medium" : _size, isLoading = props.isLoading, activity = props.activity, currentUser = props.currentUser, _showActivityType = props.showActivityType, showActivityType = _showActivityType === void 0 ? false : _showActivityType, _showHotIcon = props.showHotIcon, showHotIcon = _showHotIcon === void 0 ? false : _showHotIcon, _searchKeyword = props.searchKeyword, searchKeyword = _searchKeyword === void 0 ? "" : _searchKeyword, initScrapIcon = props.scrapIcon, _showScrapCount = props.showScrapCount, showScrapCount = _showScrapCount === void 0 ? true : _showScrapCount, scrapRefetchQueries = props.scrapRefetchQueries, linkProps = props.linkProps, itemTitle = props.itemTitle, isRecommend = props.isRecommend;
    var scrapIcon = initScrapIcon !== null && initScrapIcon !== void 0 ? initScrapIcon : /*#__PURE__*/ (0,jsx_runtime.jsx)(BookMark/* default */.Z, {
        className: "icon-bookmark",
        isOn: activity === null || activity === void 0 ? void 0 : activity.isScrapped,
        strokeType: "#666666"
    });
    var activityTypeText = get_default()(typeText/* ACTIVITY_TYPE_TEXT */.DK, (activity === null || activity === void 0 ? void 0 : activity.type) || "", "");
    var isRecruit = (activity === null || activity === void 0 ? void 0 : activity.type) === enums/* ActivityTypeID.RECRUIT */.kF.RECRUIT;
    var isIntern = router.pathname.includes("intern") || ((ref = state.filterBy.jobTypes) === null || ref === void 0 ? void 0 : ref.includes(graphql/* JobType.INTERN */.O4l.INTERN));
    var ref6;
    var categories = ((ref6 = activity === null || activity === void 0 ? void 0 : activity.categories) !== null && ref6 !== void 0 ? ref6 : []).map(function(category) {
        return category === null || category === void 0 ? void 0 : category.name;
    });
    var internTypesCount = activity === null || activity === void 0 ? void 0 : activity.recruitInformations.map(function(info) {
        var _length;
        return (_length = info === null || info === void 0 ? void 0 : info.internTypes.length) !== null && _length !== void 0 ? _length : 0;
    }).reduce(function(accumulator, currentValue) {
        return accumulator + currentValue;
    }, 0);
    var highlightedTitle = (0,useKeywordHighlighter/* default */.Z)({
        text: itemTitle || (activity === null || activity === void 0 ? void 0 : activity.title) || "",
        keyword: searchKeyword
    });
    var handleClickOrganization = function() {
        var ref;
        if (activity === null || activity === void 0 ? void 0 : (ref = activity.manager) === null || ref === void 0 ? void 0 : ref.channel) {
            router.push((0,util/* getWebviewHref */.ys)("/channel/".concat(activity.manager.channel.url), isWebview));
        }
    };
    var viewCount = (0,getViewCount/* getViewCount */.u)((activity === null || activity === void 0 ? void 0 : activity.viewCount) || 0);
    var imageUrl = isRecruit ? (activity === null || activity === void 0 ? void 0 : (ref1 = activity.logoImage) === null || ref1 === void 0 ? void 0 : ref1.url) || "" : (activity === null || activity === void 0 ? void 0 : (ref2 = activity.thumbnailImage) === null || ref2 === void 0 ? void 0 : ref2.url) || "";
    var ref7;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ActivityListItem_mobile_StyledWrapper, {
        className: (0,clsx_m/* default */.Z)(className, {
            large: size === "large"
        }),
        "data-activityid": activity === null || activity === void 0 ? void 0 : activity.id,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "img-wrapper",
                onClick: handleClickOrganization,
                children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                    width: 60,
                    height: 60
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "img-thumbnail",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        loader: optimizeImageUrl/* imageLoader */.X,
                        width: recruitImageSize/* RECRUIT_LOGO_IMAGE_SIZE */.XM,
                        height: recruitImageSize/* RECRUIT_LOGO_IMAGE_SIZE */.XM,
                        alt: (ref7 = activity === null || activity === void 0 ? void 0 : activity.title) !== null && ref7 !== void 0 ? ref7 : "",
                        src: (0,optimizeImageUrl/* optimizeImageUrl */.m)({
                            url: imageUrl,
                            width: recruitImageSize/* RECRUIT_LOGO_IMAGE_SIZE */.XM,
                            height: "auto"
                        }),
                        quality: 100,
                        objectFit: "contain"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "recruit-content",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "content-wrapper",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "organization-wrapper",
                                children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                    height: 13,
                                    width: 100
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        showHotIcon && /*#__PURE__*/ (0,jsx_runtime.jsx)(OldChip/* default */.Z, {
                                            className: (0,clsx_m/* default */.Z)("chip", "hot"),
                                            classes: {
                                                label: "label-chip"
                                            },
                                            label: "HOT",
                                            color: "primary",
                                            size: "small"
                                        }),
                                        showActivityType && activityTypeText && /*#__PURE__*/ (0,jsx_runtime.jsx)(OldChip/* default */.Z, {
                                            className: "chip",
                                            classes: {
                                                label: "label-chip"
                                            },
                                            label: activityTypeText,
                                            color: "primary",
                                            size: "small"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "container",
                                            children: [
                                                isRecommend && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "recommand-tag-container",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "recommand-text",
                                                        children: "추천"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    style: {
                                                        cursor: (activity === null || activity === void 0 ? void 0 : (ref3 = activity.manager) === null || ref3 === void 0 ? void 0 : ref3.channel) === undefined || (activity === null || activity === void 0 ? void 0 : (ref4 = activity.manager) === null || ref4 === void 0 ? void 0 : ref4.channel) === null ? "default" : "pointer"
                                                    },
                                                    className: "organization-name",
                                                    onClick: handleClickOrganization,
                                                    children: activity === null || activity === void 0 ? void 0 : activity.organizationName
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "recruit-title",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                    className: "link"
                                }, (activity === null || activity === void 0 ? void 0 : activity.id) ? {
                                    href: "/activity/[id]",
                                    as: "/activity/".concat(activity === null || activity === void 0 ? void 0 : activity.id)
                                } : {
                                    href: ""
                                }), {
                                    naked: true
                                }), linkProps), {
                                    children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                        height: 13
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "title",
                                        dangerouslySetInnerHTML: {
                                            __html: highlightedTitle
                                        }
                                    })
                                }))
                            }),
                            (props === null || props === void 0 ? void 0 : (ref5 = props.renderSecondary) === null || ref5 === void 0 ? void 0 : ref5.call(props)) || renderSecondary()
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "scrap-container",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ActivityScrap/* default */.Z, {
                            activity: activity,
                            currentUser: currentUser,
                            refetchQueries: scrapRefetchQueries,
                            children: function(param) {
                                var scrapActivity = param.scrapActivity, loading = param.loading, scrapCount = param.scrapCount;
                                /*#__PURE__*/ return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                            onClick: scrapActivity,
                                            className: (0,clsx_m/* default */.Z)("button-scrap", {
                                                scrapped: activity === null || activity === void 0 ? void 0 : activity.isScrapped
                                            }),
                                            disabled: loading,
                                            children: !loading ? scrapIcon : /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
                                                size: 18
                                            })
                                        }),
                                        showScrapCount && (isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                            height: 13,
                                            width: 20,
                                            className: "scrap-count-skeleton"
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: (0,clsx_m/* default */.Z)("scrap-count", {
                                                scrapped: activity === null || activity === void 0 ? void 0 : activity.isScrapped
                                            }),
                                            children: scrapCount
                                        }))
                                    ]
                                });
                            }
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var ActivityListItem_mobile = (ActivityListItem);
var ActivityListItem_mobile_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ActivityListItem.mobile__StyledWrapper",
    componentId: "sc-c96636e5-0"
})(ActivityListItem_mobile_templateObject2(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(ActivityListItem_mobile_templateObject1(), theme.breakpoints.up("md"), theme.breakpoints.down("md"), theme.breakpoints.down("sm"), theme.color.secondary_1, theme.color.primary_2, theme.color.primary_2, theme.color.text_3, theme.color.primary_2);
});

;// CONCATENATED MODULE: ./src/app.feature/recruitList/component/recruitListTable/component/mobile/component/RecruitListItem.mobile.tsx

function RecruitListItem_mobile_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment RecruitListItem_currentUser on User {\n    id\n    ...ActivityTableRow_currentUser\n    ...ActivityListItem_currentUser\n  }\n  fragment RecruitListItem_activity on Activity {\n    id\n    ...ActivityTableRow_activity\n    ...ActivityListItem_activity\n  }\n"
    ]);
    RecruitListItem_mobile_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



src_default()(RecruitListItem_mobile_templateObject());
var RecruitListItemMobile = function(props) {
    var isLoading = props.isLoading, activity = props.activity, currentUser = props.currentUser, isRecommend = props.isRecommend, linkProps = props.linkProps;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ActivityListItem_mobile, {
        className: "activity-list-item",
        currentUser: currentUser,
        activity: activity,
        isLoading: isLoading,
        isRecommend: isRecommend,
        linkProps: linkProps
    });
};
/* harmony default export */ var RecruitListItem_mobile = (RecruitListItemMobile);

;// CONCATENATED MODULE: ./src/app.feature/recruitList/component/recruitListTable/component/RecruitListSkeleton.tsx




// Todo: image size fix
var RecruitListSkeleton = function(param) {
    var isMobile = param.isMobile, _skeletonCount = param.skeletonCount, skeletonCount = _skeletonCount === void 0 ? 20 : _skeletonCount;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: new Array(skeletonCount).fill("").map(function(_, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                children: isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(RecruitListItem_mobile, {
                    isLoading: true
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(RecruitListItem_desktop, {
                    isLoading: true
                })
            }, "recruit-list-skeleton-".concat(index, "-isMobile-").concat(isMobile));
        })
    });
};
/* harmony default export */ var component_RecruitListSkeleton = (RecruitListSkeleton);

// EXTERNAL MODULE: ./src/app.feature/ad/constants/gtm.ts
var gtm = __webpack_require__(80979);
// EXTERNAL MODULE: ./src/app.feature/ad/modules/gtmEvents.ts
var gtmEvents = __webpack_require__(24033);
;// CONCATENATED MODULE: ./src/app.feature/ad/desktop/NoticeBanner/RecruitIntern/NoticeBannerRecruitIntern.desktop.tsx






var NoticeBannerRecruitInternDesktop = function(param) {
    var ads = param.ads, currentUser = param.currentUser;
    var router = (0,next_router.useRouter)();
    var pathname = router.pathname;
    var processedCampaignIds = (0,react.useRef)(new Set());
    var getEventNameByPath = function() {
        if (pathname.includes("/intern")) {
            return gtm/* ACTIVITY_GTM_EVENT.INTERN_NOTICE */.U.INTERN_NOTICE;
        }
        return gtm/* ACTIVITY_GTM_EVENT.RECRUIT_NOTICE */.U.RECRUIT_NOTICE;
    };
    var handleOnClickAd = function(campaignId) {
        if (!campaignId) {
            return;
        }
        (0,gtmEvents/* pushGTMCampaignId */.h)({
            eventName: getEventNameByPath().PC.CLICK_EVENT,
            campaignId: campaignId
        });
    };
    (0,react.useEffect)(function() {
        ads === null || ads === void 0 ? void 0 : ads.forEach(function(ad) {
            var ref, ref1;
            var campaignId = ad === null || ad === void 0 ? void 0 : (ref = ad.ad) === null || ref === void 0 ? void 0 : (ref1 = ref.campaign) === null || ref1 === void 0 ? void 0 : ref1.id;
            if (campaignId && !processedCampaignIds.current.has(campaignId)) {
                processedCampaignIds.current.add(campaignId);
                (0,gtmEvents/* pushGTMCampaignId */.h)({
                    eventName: getEventNameByPath().PC.IMPRESSION_EVENT,
                    campaignId: campaignId
                });
            }
        });
    }, [
        ads
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: ads === null || ads === void 0 ? void 0 : ads.map(function(ad) {
            var ref, ref1;
            var campaignId = ad === null || ad === void 0 ? void 0 : (ref = ad.ad) === null || ref === void 0 ? void 0 : (ref1 = ref.campaign) === null || ref1 === void 0 ? void 0 : ref1.id;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RecruitListItem_desktop, {
                    activity: ad.activity,
                    currentUser: currentUser,
                    isRecommend: true,
                    onClick: function() {
                        return handleOnClickAd(campaignId);
                    }
                })
            }, "activity-list-intern-item-root-".concat(ad.activity.id));
        })
    });
};
/* harmony default export */ var NoticeBannerRecruitIntern_desktop = (NoticeBannerRecruitInternDesktop);

;// CONCATENATED MODULE: ./src/app.feature/ad/desktop/NoticeBanner/RecruitIntern/NoticeBannerRecruitInternStatus.desktop.tsx








var _obj;
var RECRUIT_TYPE_TO_AD_CODE = (_obj = {}, (0,_define_property/* default */.Z)(_obj, enums/* ActivityTypeID.RECRUIT */.kF.RECRUIT, adCode/* ACTIVITY_NOTICE_AD_CODE_ID.RECRUIT_NOTICE */.s6.RECRUIT_NOTICE), (0,_define_property/* default */.Z)(_obj, enums/* ActivityTypeID.INTERN */.kF.INTERN, adCode/* ACTIVITY_NOTICE_AD_CODE_ID.INTERN_NOTICE */.s6.INTERN_NOTICE), _obj);
var NoticeBannerRecruitInternStatusDesktop = function(param) {
    var activityType = param.activityType, currentUser = param.currentUser;
    var ref = (0,useGetActivityListFromAdsByPlacementCode/* default */.Z)({
        adPlacementCode: RECRUIT_TYPE_TO_AD_CODE[activityType],
        activityTypeID: activityType
    }), ads = ref.ads, loading = ref.loading, error = ref.error;
    if (loading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(component_RecruitListSkeleton, {
            skeletonCount: constants/* TOTAL_AD_SLOTS */.a0
        });
    }
    if (error || !(ads === null || ads === void 0 ? void 0 : ads.length)) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(NoticeBannerRecruitIntern_desktop, {
        ads: ads,
        currentUser: currentUser
    });
};
/* harmony default export */ var NoticeBannerRecruitInternStatus_desktop = (NoticeBannerRecruitInternStatusDesktop);

;// CONCATENATED MODULE: ./src/app.feature/ad/hooks/useCheckQueryParamsForRecruitAds.ts



/**
 * 필터링, 정렬 및 activities 값 존재 여부를 바탕으로 인턴, 채용 배너 표시 가능 여부를 확인하는 훅
 *
 * @param {Object} params - 파라미터 객체
 * @param {ReturnType<typeof omitBy>} params.filters - 적용된 필터 object
 * @param {ActivityOrderField} params.currentOrderByField - 현재 적용된 정렬 필드
 * @param {boolean} params.hasActivities - 공고 존재 여부
 * @returns {{isShowNoticeBanner: boolean}} 공지 배너 표시 여부를 나타내는 boolean 값을 포함한 object
 *
 * @description
 * 모집 공지 배너 노출 조건
 * - 적용된 필터가 없는 경우 허용
 * - page가 1이거나 존재하지 않는 경우 허용
 * - 정렬 필드가 RECENT인 경우 허용
 * - 활동이 존재하는 경우 허용
 */ var useCheckQueryParamsForRecruitAds = function(param) {
    var filters = param.filters, currentOrderByField = param.currentOrderByField, hasActivities = param.hasActivities;
    var router = (0,next_router.useRouter)();
    var page = router.query.page;
    var isShowNoticeBanner = isEmpty_default()(filters) && (page === "1" || !page) && currentOrderByField === graphql/* ActivityOrderField.RECENT */.Ehb.RECENT && hasActivities;
    return {
        isShowNoticeBanner: isShowNoticeBanner
    };
};
/* harmony default export */ var hooks_useCheckQueryParamsForRecruitAds = (useCheckQueryParamsForRecruitAds);

;// CONCATENATED MODULE: ./src/app.feature/recruitList/component/recruitListTable/component/desktop/ListTable.desktop.tsx

function ListTable_desktop_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    background-color: #ffffff;\n\n    .recruit-list-table {\n      width: 100%;\n      height: 100%;\n      table-layout: fixed;\n\n      &:first-child {\n        border-top: 0;\n      }\n\n      caption {\n        width: 0;\n        height: 0;\n        font-size: 0;\n      }\n\n      colgroup {\n        col {\n          &[data-col='recruit-company'] {\n            width: 20%;\n          }\n          &[data-col='recruit-name'] {\n          }\n          &[data-col='recruit-type'] {\n            width: 10%;\n          }\n          &[data-col='location'] {\n            width: 10%;\n          }\n          &[data-col='recruit-close'] {\n            width: 10%;\n          }\n          &[data-col='view-count'] {\n            width: 8%;\n          }\n          &[data-col='scrap'] {\n            width: 5%;\n          }\n        }\n      }\n\n      thead {\n        tr {\n          border-top: 1px solid #999999;\n\n          th {\n            padding: 16px 0;\n            text-align: center;\n\n            p {\n              font-size: 15px;\n              color: ",
        ";\n              font-weight: 500;\n              letter-spacing: -0.5px;\n\n              &.text-blind {\n                font-size: 0;\n              }\n            }\n          }\n        }\n      }\n\n      tbody {\n        tr {\n          border-top: 1px solid ",
        ";\n\n          td {\n            max-height: 100px;\n            font-size: 16px;\n            padding: 20px 0;\n            text-align: center;\n            line-height: 16px;\n\n            &:nth-child(2) {\n              text-align: left;\n              padding: 20px;\n            }\n\n            .list-no-data {\n              text-align: center;\n              padding: 5px;\n              border-bottom: 0;\n            }\n\n            &[colspan='7'] {\n              padding: 0;\n\n              .ad-manager-container {\n                width: 100%;\n                height: 100%;\n                display: flex;\n                align-items: center;\n              }\n              iframe {\n                height: 102px;\n              }\n            }\n          }\n        }\n      }\n    }\n  "
    ]);
    ListTable_desktop_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ListTable_desktop_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    ListTable_desktop_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}







var ListTableDesktop = function(param) {
    var loading = param.loading, data = param.data, error = param.error, filters = param.filters, currentOrderByField = param.currentOrderByField, activityType = param.activityType;
    var renderList = function renderList() {
        if (error) return null;
        if (loading) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(component_RecruitListSkeleton, {});
        }
        if (nodes.length === 0) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                    colSpan: 7,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "list-no-data",
                        children: "검색결과가 없습니다."
                    })
                })
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: nodes.map(function(node) {
                /*#__PURE__*/ return (0,jsx_runtime.jsx)(react.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RecruitListItem_desktop, {
                        activity: node,
                        currentUser: data === null || data === void 0 ? void 0 : data.currentUser
                    })
                }, node.id);
            })
        });
    };
    var ref;
    var nodes = (data === null || data === void 0 ? void 0 : (ref = data.activities) === null || ref === void 0 ? void 0 : ref.nodes) || [];
    var isShowNoticeBanner = hooks_useCheckQueryParamsForRecruitAds({
        filters: filters,
        currentOrderByField: currentOrderByField,
        hasActivities: nodes.length > 0
    }).isShowNoticeBanner;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ListTable_desktop_StyledWrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
            className: "recruit-list-table",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("caption", {
                    children: "공고 리스트"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("colgroup", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                            "data-col": "recruit-company"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                            "data-col": "recruit-name"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                            "data-col": "recruit-type"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                            "data-col": "location"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                            "data-col": "recruit-close"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                            "data-col": "view-count"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                            "data-col": "scrap"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                scope: "col",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "기업명"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                scope: "col",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "공고명"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                scope: "col",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "채용형태"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                scope: "col",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "근무지역"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                scope: "col",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "마감일"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                scope: "col",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "조회수"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                scope: "col",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-blind",
                                    children: "스크랩"
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("tbody", {
                    children: [
                        isShowNoticeBanner && /*#__PURE__*/ (0,jsx_runtime.jsx)(NoticeBannerRecruitInternStatus_desktop, {
                            activityType: activityType
                        }),
                        renderList()
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var ListTable_desktop = (ListTableDesktop);
var ListTable_desktop_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ListTable.desktop__StyledWrapper",
    componentId: "sc-379d946e-0"
})(ListTable_desktop_templateObject1(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(ListTable_desktop_templateObject(), theme.color.text_1, theme.background.bg_1);
});

;// CONCATENATED MODULE: ./src/app.feature/ad/mobile/NoticeBanner/RecruitIntern/NoticeBannerRecruitIntern.mobile.tsx







var NoticeBannerRecruitInternMobile = function(param) {
    var ads = param.ads, currentUser = param.currentUser;
    var router = (0,next_router.useRouter)();
    var pathname = router.pathname;
    var processedCampaignIds = (0,react.useRef)(new Set());
    var getEventNameByPath = function() {
        if (pathname.includes("/intern")) {
            return gtm/* ACTIVITY_GTM_EVENT.INTERN_NOTICE */.U.INTERN_NOTICE;
        }
        return gtm/* ACTIVITY_GTM_EVENT.RECRUIT_NOTICE */.U.RECRUIT_NOTICE;
    };
    var handleOnClickAd = function(campaignId) {
        if (!campaignId) {
            return;
        }
        (0,gtmEvents/* pushGTMCampaignId */.h)({
            eventName: getEventNameByPath().MOBILE.CLICK_EVENT,
            campaignId: campaignId
        });
    };
    (0,react.useEffect)(function() {
        ads === null || ads === void 0 ? void 0 : ads.forEach(function(ad) {
            var ref, ref1;
            var campaignId = ad === null || ad === void 0 ? void 0 : (ref = ad.ad) === null || ref === void 0 ? void 0 : (ref1 = ref.campaign) === null || ref1 === void 0 ? void 0 : ref1.id;
            if (campaignId && !processedCampaignIds.current.has(campaignId)) {
                processedCampaignIds.current.add(campaignId);
                (0,gtmEvents/* pushGTMCampaignId */.h)({
                    eventName: getEventNameByPath().MOBILE.IMPRESSION_EVENT,
                    campaignId: campaignId
                });
            }
        });
    }, [
        ads
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: ads.map(function(ad) {
            var ref, ref1;
            var campaignId = ad === null || ad === void 0 ? void 0 : (ref = ad.ad) === null || ref === void 0 ? void 0 : (ref1 = ref.campaign) === null || ref1 === void 0 ? void 0 : ref1.id;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RecruitListItem_mobile, (0,_object_spread/* default */.Z)({
                    activity: ad.activity,
                    currentUser: currentUser,
                    isRecommend: true
                }, campaignId && {
                    linkProps: {
                        onClick: function() {
                            return handleOnClickAd(campaignId);
                        }
                    }
                }))
            }, "activity-list-intern-item-root-".concat(ad.activity.id));
        })
    });
};
/* harmony default export */ var NoticeBannerRecruitIntern_mobile = (NoticeBannerRecruitInternMobile);

;// CONCATENATED MODULE: ./src/app.feature/ad/mobile/NoticeBanner/RecruitIntern/NoticeBannerRecruitInternStatus.mobile.tsx






var NoticeBannerRecruitInternStatusMobile = function(param) {
    var activityType = param.activityType, currentUser = param.currentUser;
    var ref = (0,useGetActivityListFromAdsByPlacementCode/* default */.Z)({
        adPlacementCode: RECRUIT_TYPE_TO_AD_CODE[activityType],
        activityTypeID: activityType
    }), ads = ref.ads, loading = ref.loading, error = ref.error;
    if (loading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(component_RecruitListSkeleton, {
            isMobile: true,
            skeletonCount: constants/* TOTAL_AD_SLOTS */.a0
        });
    }
    if (error || !(ads === null || ads === void 0 ? void 0 : ads.length)) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(NoticeBannerRecruitIntern_mobile, {
        ads: ads,
        currentUser: currentUser
    });
};
/* harmony default export */ var NoticeBannerRecruitInternStatus_mobile = (NoticeBannerRecruitInternStatusMobile);

;// CONCATENATED MODULE: ./src/app.feature/recruitList/component/recruitListTable/component/mobile/ListTable.mobile.tsx

function ListTable_mobile_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: #ffffff;\n\n  .list-no-data {\n    padding: 40px;\n    text-align: center;\n  }\n"
    ]);
    ListTable_mobile_templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var ListTableMobile = function(param) {
    var loading = param.loading, data = param.data, error = param.error, filters = param.filters, currentOrderByField = param.currentOrderByField, activityType = param.activityType;
    var renderList = function renderList() {
        if (error) return null;
        if (loading) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(component_RecruitListSkeleton, {
                isMobile: true
            });
        }
        if (nodes.length === 0) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "list-no-data",
                children: "검색결과가 없습니다."
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: nodes.map(function(node) {
                /*#__PURE__*/ return (0,jsx_runtime.jsx)(react.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RecruitListItem_mobile, {
                        activity: node,
                        currentUser: data === null || data === void 0 ? void 0 : data.currentUser
                    })
                }, node.id);
            })
        });
    };
    var ref;
    var nodes = (data === null || data === void 0 ? void 0 : (ref = data.activities) === null || ref === void 0 ? void 0 : ref.nodes) || [];
    var isShowNoticeBanner = hooks_useCheckQueryParamsForRecruitAds({
        filters: filters,
        currentOrderByField: currentOrderByField,
        hasActivities: nodes.length > 0
    }).isShowNoticeBanner;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ListTable_mobile_StyledWrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                isShowNoticeBanner && /*#__PURE__*/ (0,jsx_runtime.jsx)(NoticeBannerRecruitInternStatus_mobile, {
                    activityType: activityType,
                    currentUser: data === null || data === void 0 ? void 0 : data.currentUser
                }),
                renderList()
            ]
        })
    });
};
/* harmony default export */ var ListTable_mobile = (ListTableMobile);
var ListTable_mobile_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ListTable.mobile__StyledWrapper",
    componentId: "sc-8525cd40-0"
})(ListTable_mobile_templateObject());

;// CONCATENATED MODULE: ./src/app.feature/recruitList/component/recruitListTable/RecruitListTable.tsx


function RecruitListTable_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query RecruitList(\n    $filterBy: ActivityFilter\n    $pageSize: Int!\n    $page: Int!\n    $activityOrder: ActivityOrder\n  ) {\n    currentUser {\n      ...RecruitListItem_currentUser\n    }\n    activities(\n      filterBy: $filterBy\n      pagination: { page: $page, pageSize: $pageSize }\n      orderBy: $activityOrder\n    ) {\n      totalCount\n      nodes {\n        id\n        ...RecruitListItem_activity\n      }\n    }\n    fallbackActivities: activities(\n      filterBy: $filterBy\n      pagination: { page: 1, pageSize: 4 }\n      orderBy: { direction: DESC, field: SCRAP_COUNT }\n    ) {\n      totalCount\n      nodes {\n        id\n        ...RecruitListItem_activity\n      }\n    }\n  }\n"
    ]);
    RecruitListTable_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function RecruitListTable_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: ",
        ";\n  "
    ]);
    RecruitListTable_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function RecruitListTable_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    RecruitListTable_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
















src_default()(RecruitListTable_templateObject());
var RecruitListTable_PAGE_SIZE = 20;
var RecruitListTable = function(param) {
    var activityType = param.activityType, fixedFilterBy = param.fixedFilterBy;
    var ref;
    var isMobile = (0,context/* useUA */.nD)().isMobile;
    var state = (0,react.useContext)(recruitList_context/* RecruitListScreenContext */.HR).state;
    var filters = omitBy_default()(state.filterBy, (isEmpty_default()));
    var jobCategoryStore = (0,store_jobCategory/* default */.Z)();
    var variables = (0,react.useMemo)(function() {
        var result = {
            filterBy: (0,_object_spread/* default */.Z)({
                status: graphql/* ActivityStatus.OPEN */.fUI.OPEN,
                activityTypeID: String(enums/* ActivityTypeID.RECRUIT */.kF.RECRUIT)
            }, filters, fixedFilterBy, !isMobile && {
                categoryIDs: jobCategoryStore.showSelectedIds
            }),
            activityOrder: {
                field: state.orderBy.field,
                direction: state.orderBy.direction
            },
            page: state.page,
            pageSize: RecruitListTable_PAGE_SIZE
        };
        return result;
    }, [
        filters,
        fixedFilterBy,
        isMobile,
        jobCategoryStore.showSelectedIds,
        state, 
    ]);
    var ref1 = (0,graphql/* useRecruitListQuery */.bZm)({
        notifyOnNetworkStatusChange: true,
        variables: variables
    }), data = ref1.data, loading = ref1.loading, error = ref1.error;
    var totalCount = (data === null || data === void 0 ? void 0 : (ref = data.activities) === null || ref === void 0 ? void 0 : ref.totalCount) || 0;
    hook_useRecruitFilterSyncToUrlQuery(variables);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(RecruitListTable_StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(component_RecruitListOrderBy, {
                activityConnection: data === null || data === void 0 ? void 0 : data.activities
            }),
            isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(ListTable_mobile, {
                activityType: activityType,
                loading: loading,
                data: data,
                error: error,
                filters: filters,
                currentOrderByField: state.orderBy.field
            }),
            !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(ListTable_desktop, {
                activityType: activityType,
                loading: loading,
                data: data,
                error: error,
                filters: filters,
                currentOrderByField: state.orderBy.field
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(component_RecruitListPagination, {
                totalCount: totalCount
            })
        ]
    });
};
/* harmony default export */ var recruitListTable_RecruitListTable = (RecruitListTable);
var RecruitListTable_StyledWrapper = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "RecruitListTable__StyledWrapper",
    componentId: "sc-94e07020-0"
})(RecruitListTable_templateObject2(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(RecruitListTable_templateObject1(), theme.isMobile ? "15px" : "37px");
});


/***/ }),

/***/ 24600:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "HR": function() { return /* binding */ RecruitListScreenContext; },
  "U9": function() { return /* binding */ RecruitListScreenContextProvider; },
  "aY": function() { return /* binding */ getInitialState; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/lodash/isEqual.js
var isEqual = __webpack_require__(18446);
var isEqual_default = /*#__PURE__*/__webpack_require__.n(isEqual);
// EXTERNAL MODULE: ./node_modules/lodash/merge.js
var merge = __webpack_require__(82492);
var merge_default = /*#__PURE__*/__webpack_require__.n(merge);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/generated/graphql.ts
var graphql = __webpack_require__(47079);
// EXTERNAL MODULE: ./src/app.feature/activityList/module/context/orderByReducer.ts
var orderByReducer = __webpack_require__(1869);
// EXTERNAL MODULE: ./src/app.feature/activityList/module/context/pageReducer.ts
var pageReducer = __webpack_require__(57346);
// EXTERNAL MODULE: ./src/app.feature/jobCategory/store/store.jobCategory.ts + 6 modules
var store_jobCategory = __webpack_require__(76591);
// EXTERNAL MODULE: ./src/constants/enums.ts
var enums = __webpack_require__(35460);
// EXTERNAL MODULE: ./src/hooks/useSessionFilterParams.ts
var useSessionFilterParams = __webpack_require__(93036);
;// CONCATENATED MODULE: ./src/app.feature/recruitList/module/saveSessionFilter.ts
var checkSessionFilter = function(recruitType, query) {
    if (true) {
        var savedQuery = sessionStorage.getItem("".concat(recruitType, "Filter"));
        return savedQuery ? JSON.parse(savedQuery) : query;
    }
    return query;
};
var parseFilterByParams = function(query, filterKeys) {
    var filterByParams = {};
    filterKeys.forEach(function(key) {
        var queryKey = "filterBy_".concat(key);
        if (query[queryKey]) {
            var _queryKey;
            var value = (_queryKey = query[queryKey]) !== null && _queryKey !== void 0 ? _queryKey : "";
            filterByParams[key] = normalizeFilterValue(key, value);
        } else {
            filterByParams[key] = key === "q" ? "" : [];
        }
    });
    return filterByParams;
};
var normalizeFilterValue = function(key, value) {
    if (key === "q") {
        // 검색어는 항상 문자열
        return Array.isArray(value) ? value[0] || "" : value;
    }
    // 다른 필터들은 배열
    return Array.isArray(value) ? value : [
        value
    ];
};

;// CONCATENATED MODULE: ./src/app.feature/recruitList/context/activityTypeIdReducer.ts
var activityTypeIdReducer = function(activityTypeId, action) {
    if (action.type === "ACTIVITY_TYPE_ID_ACTION") {
        return action.activityTypeId;
    }
    return activityTypeId;
};
/* harmony default export */ var context_activityTypeIdReducer = (activityTypeIdReducer);

// EXTERNAL MODULE: ./node_modules/immer/dist/immer.esm.js
var immer_esm = __webpack_require__(18172);
;// CONCATENATED MODULE: ./src/app.feature/recruitList/context/filterByReducer.ts


var filterByReducer = function(filterBy, action) {
    (0,immer_esm/* enableES5 */.pV)();
    return (0,immer_esm/* produce */.Uy)(filterBy, function(draft) {
        switch(action.type){
            case "FILTER_BY_TOGGLE_FILTER_ITEM":
                {
                    var updateField = draft[action.fieldName];
                    var filterItem = action.listItem;
                    if (updateField && typeof updateField !== "string" && action.fieldName !== "q") {
                        var index = updateField === null || updateField === void 0 ? void 0 : updateField.findIndex(function(item) {
                            return item === filterItem.id;
                        });
                        if (index !== -1) {
                            var ref;
                            (ref = draft[action.fieldName]) === null || ref === void 0 ? void 0 : ref.splice(index, 1);
                        } else {
                            // @ts-ignore
                            draft[action.fieldName] = (0,_to_consumable_array/* default */.Z)(updateField).concat([
                                filterItem.id
                            ]);
                        }
                    }
                }
                break;
            case "FILTER_BY_REMOVE_FILTER_ITEM":
                {
                    var updateField1 = draft[action.fieldName];
                    var filterItem1 = action.listItem;
                    if (updateField1 && typeof updateField1 !== "string" && action.fieldName !== "q") {
                        var index1 = updateField1 === null || updateField1 === void 0 ? void 0 : updateField1.findIndex(function(item) {
                            return item === filterItem1.id;
                        });
                        if (index1 !== -1) {
                            var ref1;
                            (ref1 = draft[action.fieldName]) === null || ref1 === void 0 ? void 0 : ref1.splice(index1, 1);
                        }
                    }
                }
                break;
            case "FILTER_BY_SET_KEYWORD":
                draft.q = action.listItem || "";
                break;
            case "FILTER_BY_SET_ALL":
                draft.q = action.newState.q;
                draft.orgTypeIDs = action.newState.orgTypeIDs;
                draft.jobTypes = action.newState.jobTypes;
                draft.regionIDs = action.newState.regionIDs;
                draft.categoryIDs = action.newState.categoryIDs;
                draft.internTypeIds = action.newState.internTypeIds;
                break;
            case "FILTER_BY_RE_INIT":
                return action.state;
            case "FILTER_BY_INIT":
                return {
                    q: "",
                    orgTypeIDs: [],
                    jobTypes: [],
                    internTypeIds: [],
                    categoryIDs: [],
                    regionIDs: []
                };
            default:
                break;
        }
    });
};
/* harmony default export */ var context_filterByReducer = (filterByReducer);

;// CONCATENATED MODULE: ./src/app.feature/recruitList/context/index.tsx

















var PAGE_RESET_ACTIONS = [
    "FILTER_BY_TOGGLE_FILTER_ITEM",
    "FILTER_BY_REMOVE_FILTER_ITEM",
    "ORDER_BY_UPDATE", 
];
var getInitialState = function() {
    return {
        filterBy: {
            q: "",
            orgTypeIDs: [],
            jobTypes: [],
            categoryIDs: [],
            regionIDs: [],
            internTypeIds: []
        },
        orderBy: {
            field: graphql/* ActivityOrderField.RECENT */.Ehb.RECENT,
            direction: graphql/* OrderDirection.DESC */.N9t.DESC
        },
        page: 1,
        activityTypeId: enums/* ActivityTypeID.RECRUIT */.kF.RECRUIT
    };
};
var RecruitListScreenContext = /*#__PURE__*/ (0,react.createContext)({
    state: getInitialState(),
    dispatch: function() {}
});
var init = function(initialStateArg) {
    return (0,_object_spread/* default */.Z)({}, merge_default()(getInitialState(), initialStateArg));
};
var mainReducer = function(state, action) {
    var nextPageState = 1;
    if (!PAGE_RESET_ACTIONS.includes(action.type)) {
        nextPageState = (0,pageReducer/* default */.Z)(state.page, action);
    }
    return {
        filterBy: context_filterByReducer(state.filterBy, action),
        orderBy: (0,orderByReducer/* default */.Z)(state.orderBy, action),
        page: nextPageState,
        activityTypeId: context_activityTypeIdReducer(state.activityTypeId, action)
    };
};
var internFilterByKeys = [
    "q",
    "orgTypeIDs",
    "categoryIDs",
    "regionIDs",
    "internTypeIds", 
];
var recruitFilterByKeys = [
    "q",
    "orgTypeIDs",
    "categoryIDs",
    "regionIDs",
    "jobTypes",
    "internTypeIds", 
];
var RecruitListScreenContextProvider = function(param) {
    var children = param.children, _initialState = param.initialState, initialState = _initialState === void 0 ? getInitialState() : _initialState, onUpdate = param.onUpdate;
    var router = (0,next_router.useRouter)();
    var recruitType = router.pathname === "/list/intern" ? "intern" : "recruit";
    var filterKeys = recruitType === "intern" ? internFilterByKeys : recruitFilterByKeys;
    var filterQuery = checkSessionFilter(recruitType, router.query);
    var filterByParams = parseFilterByParams(filterQuery, filterKeys);
    var initCategories = (0,store_jobCategory/* default */.Z)(function(state) {
        return state.initCategories;
    });
    (0,graphql/* useScreenJobCategoryQuery */.utL)({
        variables: {
            filterBy: {
                activityType: graphql/* CategoryActivityType.RECRUIT */.YMW.RECRUIT,
                parentId: null
            }
        },
        onCompleted: function(data) {
            if (data.categories) {
                var validCategories = data.categories.filter(function(category) {
                    return category !== null;
                });
                initCategories(validCategories, (0,_to_consumable_array/* default */.Z)(filterByParams.categoryIDs)) // id init
                ;
            }
        }
    });
    var memoizedReducer = function(state, action) {
        var newState = mainReducer(state, action);
        if (onUpdate && action.type !== "FILTER_BY_RE_INIT" && !isEqual_default()(newState, state)) {
            onUpdate(newState);
        }
        return newState;
    };
    var ref = (0,react.useReducer)(memoizedReducer, (0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, initialState), {
        filterBy: filterByParams
    }), router.query.page && {
        page: parseInt(router.query.page, 10)
    }), init), state = ref[0], dispatch = ref[1];
    (0,useSessionFilterParams/* useSessionFilterInternRecruitParams */.f)(recruitType);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(RecruitListScreenContext.Provider, {
        value: {
            state: state,
            dispatch: dispatch
        },
        children: children
    });
};



/***/ }),

/***/ 53703:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24600);


var useRecruitListContextResetEffect = function() {
    var dispatch = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_context__WEBPACK_IMPORTED_MODULE_1__/* .RecruitListScreenContext */ .HR).dispatch;
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        dispatch({
            type: "FILTER_BY_INIT"
        });
    }, []);
};
/* harmony default export */ __webpack_exports__["Z"] = (useRecruitListContextResetEffect);


/***/ }),

/***/ 99308:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ getAddressesText; }
/* harmony export */ });
var getAddressesText = function(addresses) {
    var ref;
    if ((ref = addresses[0]) === null || ref === void 0 ? void 0 : ref.isAbroad) {
        return "해외";
    }
    if (addresses.length > 1) {
        var ref1;
        return "".concat((ref1 = addresses[0]) === null || ref1 === void 0 ? void 0 : ref1.sido, " 외 ").concat(addresses.length - 1);
    } else if (addresses.length === 1 && addresses[0]) {
        return addresses[0].sido;
    } else {
        return "-";
    }
};


/***/ }),

/***/ 79445:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ getViewCount; }
/* harmony export */ });
/**
 * @desc viewCount의 값이 9999보다 크면 '9999+'를 반환합니다.
 * @param {number} viewCount 조회수
 * @returns {number | string}
 */ var getViewCount = function(viewCount) {
    if (viewCount > 9999) {
        return "9999+";
    }
    return viewCount;
};


/***/ }),

/***/ 2226:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Gc": function() { return /* reexport */ CATEGORY_CHIP_COLOR; },
  "f6": function() { return /* reexport */ getCategoriesText; },
  "G5": function() { return /* reexport */ getRegionsText; },
  "uF": function() { return /* reexport */ getViewCount/* getViewCount */.u; }
});

// UNUSED EXPORTS: CATEGORY_IDS

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
;// CONCATENATED MODULE: ./src/app.feature/recruitList/module/getCategoriesText.ts

var CATEGORIES_LIMIT_LENGTH = 2;
/**
 * @desc 공고 카테고리 데이터를 받아서 텍스트로 반환합니다.
 * @desc 카테고리가 없으면 '-'를 반환합니다.
 * @desc 카테고리가 2개 이상이면 2개까지만 반환하고, 나머지는 '외 n개'로 표시합니다.
 * @param {ActivityTableRow_ActivityFragment['categories']} categories 공고 카테고리 데이터
 * @returns {string}
 */ var getCategoriesText = function(categories) {
    var categoryArr = (categories !== null && categories !== void 0 ? categories : []).map(function(category) {
        return category === null || category === void 0 ? void 0 : category.name;
    });
    if (categoryArr.length === 0) {
        return "-";
    } else if (categoryArr.length > CATEGORIES_LIMIT_LENGTH) {
        return categoryArr.slice(0, CATEGORIES_LIMIT_LENGTH).join(", ") + " 외 ".concat(categoryArr.length - CATEGORIES_LIMIT_LENGTH);
    } else {
        return categoryArr.join(", ");
    }
};
var CATEGORY_IDS = {
    PROGRAMMING: "559",
    DATA_SCIENCE: "562",
    AI: "566",
    IOT: "615",
    CLOUD_SECURITY: "620",
    PRODUCTIVITY: "563",
    BUSINESS: "561",
    MARKETING: "564",
    DESIGN: "565",
    ILLUSTRATION: "560",
    VIDEO_3D: "567",
    FINANCE: "568",
    LIFESTYLE: "626",
    OTHER: "636"
};
var _obj;
var CATEGORY_CHIP_COLOR = (_obj = {}, (0,_define_property/* default */.Z)(_obj, CATEGORY_IDS.PROGRAMMING, {
    backgroundColor: "#fff8f8",
    color: "#dc5252"
}), (0,_define_property/* default */.Z)(_obj, CATEGORY_IDS.DATA_SCIENCE, {
    backgroundColor: "#fff8fc",
    color: "#ce4293"
}), (0,_define_property/* default */.Z)(_obj, CATEGORY_IDS.AI, {
    backgroundColor: "#fff9f0",
    color: "#ed671b"
}), (0,_define_property/* default */.Z)(_obj, CATEGORY_IDS.IOT, {
    backgroundColor: "#fffbeb",
    color: "#a75d00"
}), (0,_define_property/* default */.Z)(_obj, CATEGORY_IDS.CLOUD_SECURITY, {
    backgroundColor: "#f6ffdd",
    color: "#226900"
}), (0,_define_property/* default */.Z)(_obj, CATEGORY_IDS.PRODUCTIVITY, {
    backgroundColor: "#fffbeb",
    color: "#a75d00"
}), (0,_define_property/* default */.Z)(_obj, CATEGORY_IDS.BUSINESS, {
    backgroundColor: "#fff9f0",
    color: "#ed671b"
}), (0,_define_property/* default */.Z)(_obj, CATEGORY_IDS.MARKETING, {
    backgroundColor: "#f4fcff",
    color: "#008bc1"
}), (0,_define_property/* default */.Z)(_obj, CATEGORY_IDS.DESIGN, {
    backgroundColor: "#f4f8ff",
    color: "#0014ff"
}), (0,_define_property/* default */.Z)(_obj, CATEGORY_IDS.ILLUSTRATION, {
    backgroundColor: "#fafafa",
    color: "#333333"
}), (0,_define_property/* default */.Z)(_obj, CATEGORY_IDS.VIDEO_3D, {
    backgroundColor: "#faf8ff",
    color: "#ba00ff"
}), (0,_define_property/* default */.Z)(_obj, CATEGORY_IDS.FINANCE, {
    backgroundColor: "#f0f0f0",
    color: "#333333"
}), (0,_define_property/* default */.Z)(_obj, CATEGORY_IDS.LIFESTYLE, {
    backgroundColor: "#fafafa",
    color: "#333333"
}), (0,_define_property/* default */.Z)(_obj, CATEGORY_IDS.OTHER, {
    backgroundColor: "#f8faff",
    color: "#333333"
}), (0,_define_property/* default */.Z)(_obj, "default", {
    backgroundColor: "#f8faff",
    color: "#333333"
}), _obj);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
;// CONCATENATED MODULE: ./src/app.feature/recruitList/module/getRegionsText.ts

/**
 * @desc 지역구, 지역을 텍스트로 변환합니다
 * @desc 지역구가 없을 경우 지역만 표시합니다
 * @desc 지역구가 있을 경우 지역구를 표시합니다
 * @desc 지역구가 없을 경우 지역구를 표시하지 않습니다
 * @param {ActivityTableRow_ActivityFragment['regionDistricts']} regionDistricts - 지역구
 * @param {ActivityTableRow_ActivityFragment['regions']} regions - 지역
 * @returns {string}
 */ var getRegionsText = function(regionDistricts, regions) {
    var districtsArr = (regionDistricts !== null && regionDistricts !== void 0 ? regionDistricts : []).map(function(regionDistrict) {
        var ref;
        return "".concat(regionDistrict === null || regionDistrict === void 0 ? void 0 : (ref = regionDistrict.region) === null || ref === void 0 ? void 0 : ref.name, "-").concat(regionDistrict === null || regionDistrict === void 0 ? void 0 : regionDistrict.name);
    });
    var regionsArr = (0,_to_consumable_array/* default */.Z)((regions !== null && regions !== void 0 ? regions : []).map(function(region) {
        return region === null || region === void 0 ? void 0 : region.name;
    })).concat((0,_to_consumable_array/* default */.Z)(districtsArr));
    if (regionsArr.length > 1) {
        return "".concat(regionsArr[0], " 외 ").concat(regionsArr.length - 1);
    } else if (regionsArr.length === 1 && regionsArr[0]) {
        return regionsArr[0];
    } else {
        return "-";
    }
};

// EXTERNAL MODULE: ./src/app.feature/recruitList/module/getViewCount.ts
var getViewCount = __webpack_require__(79445);
;// CONCATENATED MODULE: ./src/app.feature/recruitList/module/index.ts





/***/ }),

/***/ 55671:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

var parseItem = function(items) {
    return (items === null || items === void 0 ? void 0 : items.map(function(item) {
        return {
            id: (item === null || item === void 0 ? void 0 : item.__typename) === "ActivityFilterItemByID" && item.dataId || "",
            name: (item === null || item === void 0 ? void 0 : item.__typename) === "ActivityFilterItemByID" && item.name || ""
        };
    })) || [];
};
/* harmony default export */ __webpack_exports__["Z"] = (parseItem);


/***/ }),

/***/ 53518:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core_Chip__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(16204);
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41120);
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(75154);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(86010);
/* harmony import */ var svgIcons_Close__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43785);







var useStyles = (0,_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
    return (0,_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        root: {
            borderRadius: 5,
            height: 52,
            fontSize: 15
        },
        labelSmall: {
            paddingLeft: 15,
            paddingRight: 15
        },
        colorPrimary: {
            color: "#333333",
            backgroundColor: "#f2faff",
            border: "1px solid #d9e9f3"
        },
        clickable: {
            "&:active": {
                boxShadow: "none"
            }
        },
        clickableColorPrimary: {
            "&:hover, &:focus": {
                backgroundColor: "#f2faff"
            }
        },
        deletableColorPrimary: {
            "&:focus": {
                backgroundColor: "#f2faff"
            }
        },
        deleteIcon: {
            marginRight: 15,
            marginLeft: 5
        },
        deleteIconColorPrimary: {
            color: "#333333",
            width: 10,
            height: 10,
            marginRight: 15,
            marginLeft: 5,
            "&:hover": {
                color: "#000000"
            }
        },
        sizeSmall: {
            height: 39,
            fontSize: 12
        }
    });
});
function ChipDeleteIcon(_param) {
    var onClick = _param.onClick, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "onClick"
    ]);
    // https://benfrain.com/converting-divs-into-accessible-pseudo-buttons/
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        role: "button",
        "aria-pressed": "false",
        tabIndex: 0,
        onClick: onClick,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(svgIcons_Close__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props))
    });
}
var OldChip = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    var classes = useStyles();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Chip__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        classes: {
            root: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(classes.root, props === null || props === void 0 ? void 0 : (ref = props.classes) === null || ref === void 0 ? void 0 : ref.root),
            labelSmall: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(classes.labelSmall, props === null || props === void 0 ? void 0 : (ref1 = props.classes) === null || ref1 === void 0 ? void 0 : ref1.labelSmall),
            colorPrimary: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(classes.colorPrimary, props === null || props === void 0 ? void 0 : (ref2 = props.classes) === null || ref2 === void 0 ? void 0 : ref2.colorPrimary),
            clickable: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(classes.clickable, props === null || props === void 0 ? void 0 : (ref3 = props.classes) === null || ref3 === void 0 ? void 0 : ref3.clickable),
            clickableColorPrimary: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(classes.clickableColorPrimary, props === null || props === void 0 ? void 0 : (ref4 = props.classes) === null || ref4 === void 0 ? void 0 : ref4.clickableColorPrimary),
            deletableColorPrimary: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(classes.deletableColorPrimary, props === null || props === void 0 ? void 0 : (ref5 = props.classes) === null || ref5 === void 0 ? void 0 : ref5.deletableColorPrimary),
            deleteIcon: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(classes.deleteIcon, props === null || props === void 0 ? void 0 : (ref6 = props.classes) === null || ref6 === void 0 ? void 0 : ref6.deleteIcon),
            deleteIconColorPrimary: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(classes.deleteIconColorPrimary, props === null || props === void 0 ? void 0 : (ref7 = props.classes) === null || ref7 === void 0 ? void 0 : ref7.deleteIconColorPrimary),
            sizeSmall: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(classes.sizeSmall, props === null || props === void 0 ? void 0 : (ref8 = props.classes) === null || ref8 === void 0 ? void 0 : ref8.sizeSmall)
        },
        deleteIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ChipDeleteIcon, {})
    }, props));
};
/* harmony default export */ __webpack_exports__["Z"] = (OldChip);


/***/ }),

/***/ 76318:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core_Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(282);
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41120);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(86010);








var useStyle = (0,_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
    return {
        greyButton: {
            color: "white",
            backgroundColor: "#bbbbbb",
            "&:hover": {
                boxShadow: "none",
                backgroundColor: "#aaaaaa"
            },
            "&:focus": {
                boxShadow: "none"
            }
        }
    };
});
var Button = function(props) {
    var classesProp = props.classes, className = props.className, tmp = props.color, colorProp = tmp === void 0 ? "default" : tmp, buttonProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(props, [
        "classes",
        "className",
        "color"
    ]);
    var classes = useStyle();
    var color = colorProp === "grey" ? "default" : colorProp;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        color: color
    }, buttonProps), {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, classes.greyButton, colorProp === "grey"), className),
        disableElevation: true,
        classes: classesProp
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Button);


/***/ }),

/***/ 95106:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ useBodyScrollHidden; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

/**
 * @desc 팝업이 열릴 때 body 및 html 스크롤을 막습니다 훅
 * @param isLock 팝업이 열리는지 여부
 */ var useBodyScrollHidden = function(isLock) {
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (isLock) {
            document.documentElement.style.overflow = "hidden";
            document.body.style.overflow = "hidden";
            document.body.style.touchAction = "none";
        } else {
            document.documentElement.style.overflow = "";
            document.body.style.overflow = "";
            document.body.style.touchAction = "";
        }
        return function() {
            document.documentElement.style.overflow = "";
            document.body.style.overflow = "";
            document.body.style.touchAction = "";
        };
    }, [
        isLock
    ]);
};


/***/ }),

/***/ 34121:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var context__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52737);

var useCanonical = function() {
    var asPath = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    var domains = (0,context__WEBPACK_IMPORTED_MODULE_0__/* .useDomain */ .ay)();
    var protocol = domains.protocol, linkareer = domains.linkareer;
    var pathname = "".concat(protocol, "://").concat(linkareer).concat(asPath);
    return pathname;
};
/* harmony default export */ __webpack_exports__["Z"] = (useCanonical);


/***/ }),

/***/ 17683:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var keyword_highlighter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72423);
/* harmony import */ var keyword_highlighter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(keyword_highlighter__WEBPACK_IMPORTED_MODULE_1__);

// @ts-ignore

function useKeywordHighlighter(props) {
    var text = props.text, _keyword = props.keyword, keyword = _keyword === void 0 ? "" : _keyword;
    var highlightedText = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        return keyword_highlighter__WEBPACK_IMPORTED_MODULE_1___default()(keyword, text);
    }, [
        text,
        keyword
    ]);
    return keyword ? highlightedText : text;
}
/* harmony default export */ __webpack_exports__["Z"] = (useKeywordHighlighter);


/***/ }),

/***/ 93036:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ useSessionFilterInternRecruitParams; },
/* harmony export */   "t": function() { return /* binding */ useSessionFilterParams; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);


var useSessionFilterParams = function(filterType) {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        // 페이지 로드 시 세션스토리지에서 쿼리 파라미터를 가져와 적용
        var savedQuery = sessionStorage.getItem("".concat(filterType, "Filter"));
        if (savedQuery) {
            var query = JSON.parse(savedQuery);
            router.replace({
                pathname: router.pathname,
                query: query
            });
        }
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var handleRouteChange = function() {
            var query = router.query;
            if (Object.keys(query).length > 0) {
                sessionStorage.setItem("".concat(filterType, "Filter"), JSON.stringify(query));
            }
        };
        window.addEventListener("pagehide", handleRouteChange);
        router.events.on("routeChangeStart", handleRouteChange);
        return function() {
            window.removeEventListener("pagehide", handleRouteChange);
            router.events.off("routeChangeStart", handleRouteChange);
        };
    }, [
        router
    ]);
};
var useSessionFilterInternRecruitParams = function(filterType) {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var handleRouteChange = function() {
            var query = router.query;
            if (Object.keys(query).length > 0) {
                sessionStorage.setItem("".concat(filterType, "Filter"), JSON.stringify(query));
            }
        };
        window.addEventListener("beforeunload", handleRouteChange);
        router.events.on("routeChangeStart", handleRouteChange);
        return function() {
            window.removeEventListener("beforeunload", handleRouteChange);
            router.events.off("routeChangeStart", handleRouteChange);
        };
    }, [
        router
    ]);
};


/***/ }),

/***/ 65342:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ imageLoader; },
/* harmony export */   "m": function() { return /* binding */ optimizeImageUrl; }
/* harmony export */ });
var optimizeImageUrl = function(options) {
    if (!options.url) return "";
    return "".concat(options.url, "?d=").concat(options.width, "x").concat(options.height);
};
var imageLoader = function(param) {
    var src = param.src;
    return "".concat(src);
};


/***/ })

}]);